import React, { createContext, useState, useEffect, useContext, Component } from 'react';
import { MenuButton, Button, FontIcon, DialogContainer } from 'react-md';
import PropTypes from 'prop-types';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "#header-container {\n  background-color: #FFF;\n  border-bottom: 1px solid #DADCE0;\n  z-index: 19; }\n  #header-container.sticky, #header-container.stuck {\n    box-shadow: 0 4px 2px rgba(6, 6, 6, 0.33); }\n  #header-container.stuck {\n    top: 0px;\n    position: sticky; }\n  #header-container .user-avatar {\n    align-items: center;\n    background-color: #26C6DA;\n    border-radius: 50%;\n    color: #FFF;\n    display: flex;\n    font-size: 0.875rem;\n    height: 2rem;\n    justify-content: center;\n    width: 2rem; }\n\n#header {\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  height: 4rem;\n  width: 100%; }\n  #header .wrapper {\n    height: 100%;\n    max-width: 53.5rem; }\n    #header .wrapper > .row {\n      height: 100%; }\n  #header .logo-container {\n    flex-grow: 0;\n    flex-shrink: 0;\n    padding-right: 1rem; }\n    #header .logo-container img {\n      cursor: pointer; }\n    #header .logo-container button,\n    #header .logo-container img {\n      display: inline-block; }\n  #header .header-action-container {\n    flex-grow: 0;\n    flex-shrink: 0;\n    padding-left: 1rem;\n    padding-right: 1rem; }\n  #header .header-action-button {\n    color: #FFF;\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n    min-width: initial;\n    padding-left: 0;\n    padding-right: 0; }\n    #header .header-action-button:hover {\n      color: #e6e6e6; }\n    #header .header-action-button:first-of-type {\n      margin-left: 0; }\n    #header .header-action-button:last-child {\n      margin-right: 0; }\n  #header .chip {\n    background-color: transparent;\n    border: 1px solid #FFF;\n    border-radius: 0.75rem;\n    color: #FFF;\n    flex-grow: 0;\n    font-size: 0.875rem;\n    margin-right: 0.25rem;\n    padding: 0.125rem 0.375rem;\n    text-transform: lowercase; }\n  #header.header-mobile .header-menu-button-container button {\n    margin: 0 1rem; }\n  #header.header-mobile .header-action-container {\n    opacity: 1; }\n  #header.header-mobile .header-action-container,\n  #header.header-mobile .header-menu-button-container {\n    display: inline-block; }\n  #header.header-desktop {\n    justify-content: space-between;\n    padding: 0 1.25rem; }\n    #header.header-desktop .desktop-header-actions {\n      align-items: center;\n      display: flex;\n      justify-content: space-evenly; }\n      #header.header-desktop .desktop-header-actions .desktop-header-action-child {\n        margin-right: 1rem; }\n        #header.header-desktop .desktop-header-actions .desktop-header-action-child:last-child {\n          margin-right: 0; }\n\n.header-avatar-button {\n  height: 3rem;\n  width: 3rem; }\n  .header-avatar-button .user-avatar {\n    font-size: 1.5rem;\n    height: 3rem;\n    width: 3rem; }\n\n.drawer-header {\n  background-color: #F11A1A;\n  height: 9.0625rem;\n  margin-bottom: 1rem;\n  padding: 1.5rem; }\n  .drawer-header .md-btn--hover {\n    background: transparent; }\n  .drawer-header .md-btn--text {\n    padding: 0;\n    text-transform: capitalize; }\n  .drawer-header .mobile-sign-out-button {\n    display: flex;\n    width: 100%; }\n  .drawer-header .header-avatar-button {\n    color: #FFF;\n    margin: 1.25rem 0 1.6875rem; }\n    .drawer-header .header-avatar-button .md-icon {\n      color: #FFF;\n      margin-left: 0.625rem; }\n  .drawer-header .header-avatar-button-detail-container {\n    padding-left: 1.25rem; }\n    .drawer-header .header-avatar-button-detail-container .header-avatar-button-detail {\n      align-items: center;\n      display: flex;\n      justify-content: flex-start; }\n    .drawer-header .header-avatar-button-detail-container .name {\n      font-size: 1.125rem; }\n    .drawer-header .header-avatar-button-detail-container .email {\n      font-size: 0.75rem; }\n  .drawer-header .logo-container img {\n    cursor: pointer;\n    width: 12.75rem; }\n\n#user-button-mobile {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  width: 100%; }\n\n.header-avatar-button {\n  height: 3rem;\n  width: 3rem; }\n  .header-avatar-button .user-avatar {\n    border: 0.125rem solid #FFF;\n    flex-shrink: 0;\n    font-size: 1.5rem;\n    height: 3rem;\n    width: 3rem; }\n\n.mobile-sign-out-button {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  padding-left: 1.5rem;\n  width: 100%; }\n  .mobile-sign-out-button .mobile-sign-out-icon {\n    align-items: center;\n    display: flex;\n    margin-right: 1.5rem; }\n\n.collapse-button {\n  cursor: pointer;\n  transition: 250ms ease-in-out; }\n  .collapse-button.expanded {\n    transform: rotate(-180deg); }\n\n.expansion-content {\n  max-height: 0;\n  overflow: hidden; }\n  .expansion-content.expanded {\n    animation: slide-open 450ms ease-in-out;\n    max-height: 62.5rem; }\n  .expansion-content.closed {\n    animation: slide-closed 350ms ease-in-out;\n    max-height: 0; }\n\n@keyframes slide-open {\n  0% {\n    max-height: 0rem; }\n  100% {\n    max-height: 62.5rem; } }\n\n@keyframes slide-closed {\n  0% {\n    max-height: 62.5rem;\n    min-height: 0; }\n  100% {\n    max-height: 0rem; } }\n";
styleInject(css);

/**
  stickybits - Stickybits is a lightweight alternative to `position: sticky` polyfills
  @version v3.7.3
  @link https://github.com/dollarshaveclub/stickybits#readme
  @author Jeff Wainwright <yowainwright@gmail.com> (https://jeffry.in)
  @license MIT
**/
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/*
  STICKYBITS 💉
  --------
  > a lightweight alternative to `position: sticky` polyfills 🍬
  --------
  - each method is documented above it our view the readme
  - Stickybits does not manage polymorphic functionality (position like properties)
  * polymorphic functionality: (in the context of describing Stickybits)
    means making things like `position: sticky` be loosely supported with position fixed.
    It also means that features like `useStickyClasses` takes on styles like `position: fixed`.
  --------
  defaults 🔌
  --------
  - version = `package.json` version
  - userAgent = viewer browser agent
  - target = DOM element selector
  - noStyles = boolean
  - offset = number
  - parentClass = 'string'
  - scrollEl = window || DOM element selector || DOM element
  - stickyClass = 'string'
  - stuckClass = 'string'
  - useStickyClasses = boolean
  - useFixed = boolean
  - useGetBoundingClientRect = boolean
  - verticalPosition = 'string'
  - applyStyle = function
  --------
  props🔌
  --------
  - p = props {object}
  --------
  instance note
  --------
  - stickybits parent methods return this
  - stickybits instance methods return an instance item
  --------
  nomenclature
  --------
  - target => el => e
  - props => o || p
  - instance => item => it
  --------
  methods
  --------
  - .definePosition = defines sticky or fixed
  - .addInstance = an array of objects for each Stickybits Target
  - .getClosestParent = gets the parent for non-window scroll
  - .getTopPosition = gets the element top pixel position from the viewport
  - .computeScrollOffsets = computes scroll position
  - .toggleClasses = older browser toggler
  - .manageState = manages sticky state
  - .removeInstance = removes an instance
  - .cleanup = removes all Stickybits instances and cleans up dom from stickybits
*/
var Stickybits =
/*#__PURE__*/
function () {
  function Stickybits(target, obj) {
    var _this = this;

    var o = typeof obj !== 'undefined' ? obj : {};
    this.version = '3.7.3';
    this.userAgent = window.navigator.userAgent || 'no `userAgent` provided by the browser';
    this.props = {
      customStickyChangeNumber: o.customStickyChangeNumber || null,
      noStyles: o.noStyles || false,
      stickyBitStickyOffset: o.stickyBitStickyOffset || 0,
      parentClass: o.parentClass || 'js-stickybit-parent',
      scrollEl: typeof o.scrollEl === 'string' ? document.querySelector(o.scrollEl) : o.scrollEl || window,
      stickyClass: o.stickyClass || 'js-is-sticky',
      stuckClass: o.stuckClass || 'js-is-stuck',
      stickyChangeClass: o.stickyChangeClass || 'js-is-sticky--change',
      useStickyClasses: o.useStickyClasses || false,
      useFixed: o.useFixed || false,
      useGetBoundingClientRect: o.useGetBoundingClientRect || false,
      verticalPosition: o.verticalPosition || 'top',
      applyStyle: o.applyStyle || function (item, style) {
        return _this.applyStyle(item, style);
      }
      /*
        define positionVal after the setting of props, because definePosition looks at the props.useFixed
        ----
        -  uses a computed (`.definePosition()`)
        -  defined the position
      */

    };
    this.props.positionVal = this.definePosition() || 'fixed';
    this.instances = [];
    var _this$props = this.props,
        positionVal = _this$props.positionVal,
        verticalPosition = _this$props.verticalPosition,
        noStyles = _this$props.noStyles,
        stickyBitStickyOffset = _this$props.stickyBitStickyOffset;
    var verticalPositionStyle = verticalPosition === 'top' && !noStyles ? stickyBitStickyOffset + "px" : '';
    var positionStyle = positionVal !== 'fixed' ? positionVal : '';
    this.els = typeof target === 'string' ? document.querySelectorAll(target) : target;
    if (!('length' in this.els)) this.els = [this.els];

    for (var i = 0; i < this.els.length; i++) {
      var _styles;

      var el = this.els[i];
      var instance = this.addInstance(el, this.props); // set vertical position

      this.props.applyStyle({
        styles: (_styles = {}, _styles[verticalPosition] = verticalPositionStyle, _styles.position = positionStyle, _styles),
        classes: {}
      }, instance); // instances are an array of objects

      this.instances.push(instance);
    }
  }
  /*
    setStickyPosition ✔️
    --------
    —  most basic thing stickybits does
    => checks to see if position sticky is supported
    => defined the position to be used
    => stickybits works accordingly
  */


  var _proto = Stickybits.prototype;

  _proto.definePosition = function definePosition() {
    var stickyProp;

    if (this.props.useFixed) {
      stickyProp = 'fixed';
    } else {
      var prefix = ['', '-o-', '-webkit-', '-moz-', '-ms-'];
      var test = document.head.style;

      for (var i = 0; i < prefix.length; i += 1) {
        test.position = prefix[i] + "sticky";
      }

      stickyProp = test.position ? test.position : 'fixed';
      test.position = '';
    }

    return stickyProp;
  }
  /*
    addInstance ✔️
    --------
    — manages instances of items
    - takes in an el and props
    - returns an item object
    ---
    - target = el
    - o = {object} = props
      - scrollEl = 'string' | object
      - verticalPosition = number
      - off = boolean
      - parentClass = 'string'
      - stickyClass = 'string'
      - stuckClass = 'string'
    ---
    - defined later
      - parent = dom element
      - state = 'string'
      - offset = number
      - stickyStart = number
      - stickyStop = number
    - returns an instance object
  */
  ;

  _proto.addInstance = function addInstance(el, props) {
    var _this2 = this;

    var item = {
      el: el,
      parent: el.parentNode,
      props: props
    };

    if (props.positionVal === 'fixed' || props.useStickyClasses) {
      this.isWin = this.props.scrollEl === window;
      var se = this.isWin ? window : this.getClosestParent(item.el, item.props.scrollEl);
      this.computeScrollOffsets(item);
      this.toggleClasses(item.parent, '', props.parentClass);
      item.state = 'default';
      item.stateChange = 'default';

      item.stateContainer = function () {
        return _this2.manageState(item);
      };

      se.addEventListener('scroll', item.stateContainer);
    }

    return item;
  }
  /*
    --------
    getParent 👨‍
    --------
    - a helper function that gets the target element's parent selected el
    - only used for non `window` scroll elements
    - supports older browsers
  */
  ;

  _proto.getClosestParent = function getClosestParent(el, match) {
    // p = parent element
    var p = match;
    var e = el;
    if (e.parentElement === p) return p; // traverse up the dom tree until we get to the parent

    while (e.parentElement !== p) {
      e = e.parentElement;
    } // return parent element


    return p;
  }
  /*
    --------
    getTopPosition
    --------
    - a helper function that gets the topPosition of a Stickybit element
    - from the top level of the DOM
  */
  ;

  _proto.getTopPosition = function getTopPosition(el) {
    if (this.props.useGetBoundingClientRect) {
      return el.getBoundingClientRect().top + (this.props.scrollEl.pageYOffset || document.documentElement.scrollTop);
    }

    var topPosition = 0;

    do {
      topPosition = el.offsetTop + topPosition;
    } while (el = el.offsetParent);

    return topPosition;
  }
  /*
    computeScrollOffsets 📊
    ---
    computeScrollOffsets for Stickybits
    - defines
      - offset
      - start
      - stop
  */
  ;

  _proto.computeScrollOffsets = function computeScrollOffsets(item) {
    var it = item;
    var p = it.props;
    var el = it.el;
    var parent = it.parent;
    var isCustom = !this.isWin && p.positionVal === 'fixed';
    var isTop = p.verticalPosition !== 'bottom';
    var scrollElOffset = isCustom ? this.getTopPosition(p.scrollEl) : 0;
    var stickyStart = isCustom ? this.getTopPosition(parent) - scrollElOffset : this.getTopPosition(parent);
    var stickyChangeOffset = p.customStickyChangeNumber !== null ? p.customStickyChangeNumber : el.offsetHeight;
    var parentBottom = stickyStart + parent.offsetHeight;
    it.offset = !isCustom ? scrollElOffset + p.stickyBitStickyOffset : 0;
    it.stickyStart = isTop ? stickyStart - it.offset : 0;
    it.stickyChange = it.stickyStart + stickyChangeOffset;
    it.stickyStop = isTop ? parentBottom - (el.offsetHeight + it.offset) : parentBottom - window.innerHeight;
  }
  /*
    toggleClasses ⚖️
    ---
    toggles classes (for older browser support)
    r = removed class
    a = added class
  */
  ;

  _proto.toggleClasses = function toggleClasses(el, r, a) {
    var e = el;
    var cArray = e.className.split(' ');
    if (a && cArray.indexOf(a) === -1) cArray.push(a);
    var rItem = cArray.indexOf(r);
    if (rItem !== -1) cArray.splice(rItem, 1);
    e.className = cArray.join(' ');
  }
  /*
    manageState 📝
    ---
    - defines the state
      - normal
      - sticky
      - stuck
  */
  ;

  _proto.manageState = function manageState(item) {
    var _this3 = this;

    // cache object
    var it = item;
    var p = it.props;
    var state = it.state;
    var stateChange = it.stateChange;
    var start = it.stickyStart;
    var change = it.stickyChange;
    var stop = it.stickyStop; // cache props

    var pv = p.positionVal;
    var se = p.scrollEl;
    var sticky = p.stickyClass;
    var stickyChange = p.stickyChangeClass;
    var stuck = p.stuckClass;
    var vp = p.verticalPosition;
    var isTop = vp !== 'bottom';
    var aS = p.applyStyle;
    /*
      requestAnimationFrame
      ---
      - use rAF
      - or stub rAF
    */

    var rAFStub = function rAFDummy(f) {
      f();
    };

    var rAF = !this.isWin ? rAFStub : window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || rAFStub;
    /*
      define scroll vars
      ---
      - scroll
      - notSticky
      - isSticky
      - isStuck
    */

    var scroll = this.isWin ? window.scrollY || window.pageYOffset : se.scrollTop;
    var notSticky = scroll > start && scroll < stop && (state === 'default' || state === 'stuck');
    var isSticky = isTop && scroll <= start && (state === 'sticky' || state === 'stuck');
    var isStuck = scroll >= stop && state === 'sticky';
    /*
      Unnamed arrow functions within this block
      ---
      - help wanted or discussion
      - view test.stickybits.js
        - `stickybits .manageState  `position: fixed` interface` for more awareness 👀
    */

    if (notSticky) {
      it.state = 'sticky';
    } else if (isSticky) {
      it.state = 'default';
    } else if (isStuck) {
      it.state = 'stuck';
    }

    var isStickyChange = scroll >= change && scroll <= stop;
    var isNotStickyChange = scroll < change / 2 || scroll > stop;

    if (isNotStickyChange) {
      it.stateChange = 'default';
    } else if (isStickyChange) {
      it.stateChange = 'sticky';
    } // Only apply new styles if the state has changed


    if (state === it.state && stateChange === it.stateChange) return;
    rAF(function () {
      var _styles2, _classes, _styles3, _extends2, _classes2, _style$classes;

      var stateStyles = {
        sticky: {
          styles: (_styles2 = {
            position: pv,
            top: '',
            bottom: ''
          }, _styles2[vp] = p.stickyBitStickyOffset + "px", _styles2),
          classes: (_classes = {}, _classes[sticky] = true, _classes)
        },
        default: {
          styles: (_styles3 = {}, _styles3[vp] = '', _styles3),
          classes: {}
        },
        stuck: {
          styles: _extends((_extends2 = {}, _extends2[vp] = '', _extends2), pv === 'fixed' || !_this3.isWin ? {
            position: 'absolute',
            top: '',
            bottom: '0'
          } : {}),
          classes: (_classes2 = {}, _classes2[stuck] = true, _classes2)
        }
      };

      if (pv === 'fixed') {
        stateStyles.default.styles.position = '';
      }

      var style = stateStyles[it.state];
      style.classes = (_style$classes = {}, _style$classes[stuck] = !!style.classes[stuck], _style$classes[sticky] = !!style.classes[sticky], _style$classes[stickyChange] = isStickyChange, _style$classes);
      aS(style, item);
    });
  }
  /*
    applyStyle
    ---
    - apply the given styles and classes to the element
  */
  ;

  _proto.applyStyle = function applyStyle(_ref, item) {
    var styles = _ref.styles,
        classes = _ref.classes;
    // cache object
    var it = item;
    var e = it.el;
    var p = it.props;
    var stl = e.style; // cache props

    var ns = p.noStyles;
    var cArray = e.className.split(' '); // Disable due to bug with old versions of eslint-scope and for ... in
    // https://github.com/eslint/eslint/issues/12117
    // eslint-disable-next-line no-unused-vars

    for (var cls in classes) {
      var addClass = classes[cls];

      if (addClass) {
        if (cArray.indexOf(cls) === -1) cArray.push(cls);
      } else {
        var idx = cArray.indexOf(cls);
        if (idx !== -1) cArray.splice(idx, 1);
      }
    }

    e.className = cArray.join(' ');

    if (styles['position']) {
      stl['position'] = styles['position'];
    }

    if (ns) return; // eslint-disable-next-line no-unused-vars

    for (var key in styles) {
      stl[key] = styles[key];
    }
  };

  _proto.update = function update(updatedProps) {
    var _this4 = this;

    if (updatedProps === void 0) {
      updatedProps = null;
    }

    this.instances.forEach(function (instance) {
      _this4.computeScrollOffsets(instance);

      if (updatedProps) {
        // eslint-disable-next-line no-unused-vars
        for (var updatedProp in updatedProps) {
          instance.props[updatedProp] = updatedProps[updatedProp];
        }
      }
    });
    return this;
  }
  /*
    removes an instance 👋
    --------
    - cleanup instance
  */
  ;

  _proto.removeInstance = function removeInstance(instance) {
    var _styles4, _classes3;

    var e = instance.el;
    var p = instance.props;
    this.applyStyle({
      styles: (_styles4 = {
        position: ''
      }, _styles4[p.verticalPosition] = '', _styles4),
      classes: (_classes3 = {}, _classes3[p.stickyClass] = '', _classes3[p.stuckClass] = '', _classes3)
    }, instance);
    this.toggleClasses(e.parentNode, p.parentClass);
  }
  /*
    cleanup 🛁
    --------
    - cleans up each instance
    - clears instance
  */
  ;

  _proto.cleanup = function cleanup() {
    for (var i = 0; i < this.instances.length; i += 1) {
      var instance = this.instances[i];

      if (instance.stateContainer) {
        instance.props.scrollEl.removeEventListener('scroll', instance.stateContainer);
      }

      this.removeInstance(instance);
    }

    this.manageState = false;
    this.instances = [];
  };

  return Stickybits;
}();
/*
  export
  --------
  exports StickBits to be used 🏁
*/


function stickybits(target, o) {
  return new Stickybits(target, o);
}

var css$1 = "#app-dropdown-button {\n  height: 1.5rem;\n  width: 1.5rem; }\n\n#app-dropdown-toggle {\n  height: 100%;\n  margin: 0;\n  min-width: 100%;\n  padding: 0;\n  width: 100%; }\n\n#app-dropdown .md-list {\n  width: 16.5rem; }\n";
styleInject(css$1);

var css$2 = ".header-menu-btn {\n  color: #A8A8A8; }\n  .header-menu-btn.md-btn--text {\n    height: 100%;\n    margin: 0;\n    min-width: 100%;\n    padding: 0;\n    width: 100%; }\n\n.header-menu-btn-toggle.md-btn--text {\n  min-width: 1.25rem; }\n\n#notifications-dropdown-toggle {\n  display: flex;\n  justify-content: flex-end; }\n";
styleInject(css$2);

var HeaderDropDown = function HeaderDropDown(_ref) {
  var idName = _ref.idName,
      children = _ref.children,
      dropDownContent = _ref.dropDownContent;
  return React.createElement(MenuButton, {
    id: idName || 'header-dropdown',
    flat: true,
    simplifiedMenu: false,
    className: "header-menu-btn",
    primary: true,
    transitionEnterTimeout: 0,
    listHeightRestricted: false,
    listStyle: {
      top: '76px',
      right: '12px',
      left: 'auto'
    },
    menuItems: dropDownContent,
    repositionOnScroll: false
  }, children);
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/* eslint-enable */

var ExitLeftIcon = function ExitLeftIcon(props) {
  return React.createElement("svg", _extends$1({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.41 8.41L9 7l-5 5 5 5 1.41-1.41L7.83 13h9.67v-2H7.83l2.58-2.59zM19 3H5a2 2 0 0 0-2 2v5l2-2V5h14v14H5v-3l-2-2v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z",
    fill: "currentColor"
  }));
};

var AppDrawerIcon = function AppDrawerIcon(props) {
  return React.createElement("svg", _extends$1({
    viewBox: "0 0 21 21",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7h5V2H2v5zm0 6h5V8H2v5zm6 0h5V8H8v5zm6 0h5V8h-5v5zM2 19h5v-5H2v5zm6 0h5v-5H8v5zm6 0h5v-5h-5v5zM8 7h5V2H8v5zm6-5v5h5V2h-5z",
    fill: "currentColor"
  }));
};

var css$3 = "#app-dropdown-list {\n  padding-bottom: 0px; }\n\n.app-container {\n  padding-top: 1rem; }\n  .app-container .app-container-view-all {\n    align-items: center;\n    background-color: #F5F5F5;\n    box-sizing: border-box;\n    display: flex;\n    font-size: 12px;\n    height: 2.4375rem;\n    justify-content: center;\n    margin-top: 1.5rem;\n    text-transform: capitalize;\n    width: 100%; }\n  .app-container .app-icon {\n    display: inline-block;\n    height: 5.625rem;\n    text-align: center;\n    padding: 0.5rem 0.375rem;\n    width: 33%; }\n    .app-container .app-icon .app-name {\n      font-size: 0.75rem;\n      text-transform: capitalize; }\n";
styleInject(css$3);

var LEGACY_PORTAL = ['GLOBAL_ADMIN', 'OPERATOR', 'VIEWER'];
var LIVE = ['GLOBAL_ADMIN', 'OPERATOR', 'VIEWER'];
var ANALYTICS = ['GLOBAL_ADMIN', 'OPERATOR', 'VIEWER'];
var SCHEDULER = ['GLOBAL_ADMIN'];
var API = ['GLOBAL_ADMIN'];
var DEVICES = ['GLOBAL_ADMIN', 'OPERATOR', 'VIEWER'];
var EDUCATION = ['GLOBAL_ADMIN', 'OPERATOR', 'VIEWER'];
var VIP_MANAGER = ['GLOBAL_ADMIN', 'OPERATOR', 'VIEWER'];
var PREPAID_PASS_MANAGER = ['GLOBAL_ADMIN'];
var API_PROVISIONING = ['GLOBAL_ADMIN'];
var USERS = ['GLOBAL_ADMIN'];
var NETWORK_DIAGRAM = ['GLOBAL_ADMIN'];

var AnalyticsIcon$1 = function AnalyticsIcon(props) {
  return React.createElement("svg", _extends$1({
    width: "42",
    height: "42",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M11.3168 19.9935L10.2114 19.1484L17.4536 9.79919L24.5101 16.5954L31.204 11.2694L32.0706 12.3522L24.4216 18.4441L17.6039 11.8768L11.3168 19.9935Z",
    fill: "#CED5E0"
  }), React.createElement("path", {
    d: "M33.5831 33.2334H29.2237C29.1175 33.2334 29.038 33.1541 29.038 33.0485V17.3168C29.038 17.2112 29.1175 17.132 29.2237 17.132H33.5831C33.6892 17.132 33.7688 17.2112 33.7688 17.3168V33.0485C33.7688 33.1453 33.6892 33.2334 33.5831 33.2334Z",
    fill: "#319ECA"
  }), React.createElement("path", {
    d: "M26.6514 33.2333H22.292C22.1858 33.2333 22.1063 33.1541 22.1063 33.0484V21.9385C22.1063 21.8329 22.1858 21.7537 22.292 21.7537H26.6514C26.7575 21.7537 26.8371 21.8329 26.8371 21.9385V33.0484C26.8283 33.1453 26.7487 33.2333 26.6514 33.2333Z",
    fill: "#319ECA"
  }), React.createElement("path", {
    d: "M19.7088 33.2335H15.3494C15.2433 33.2335 15.1637 33.1543 15.1637 33.0487V16.3134C15.1637 16.2078 15.2433 16.1285 15.3494 16.1285H19.7088C19.815 16.1285 19.8945 16.2078 19.8945 16.3134V33.0487C19.8945 33.1455 19.815 33.2335 19.7088 33.2335Z",
    fill: "#319ECA"
  }), React.createElement("path", {
    d: "M12.7762 33.2336H8.41671C8.3106 33.2336 8.23102 33.1544 8.23102 33.0488V24.8C8.23102 24.6943 8.3106 24.6151 8.41671 24.6151H12.7762C12.8823 24.6151 12.9619 24.6943 12.9619 24.8V33.0488C12.9619 33.1456 12.8734 33.2336 12.7762 33.2336Z",
    fill: "#319ECA"
  }), React.createElement("path", {
    d: "M36.8461 32.4946H5.15387V34H36.8461V32.4946Z",
    fill: "#CED5E0"
  }), React.createElement("path", {
    d: "M31.6367 14.4038C33.0725 14.4038 34.2365 13.245 34.2365 11.8156C34.2365 10.3862 33.0725 9.22742 31.6367 9.22742C30.2009 9.22742 29.037 10.3862 29.037 11.8156C29.037 13.245 30.2009 14.4038 31.6367 14.4038Z",
    fill: "#E6E9EE"
  }), React.createElement("path", {
    d: "M31.6372 13.3208C32.4723 13.3208 33.1493 12.6468 33.1493 11.8154C33.1493 10.984 32.4723 10.3101 31.6372 10.3101C30.8021 10.3101 30.1251 10.984 30.1251 11.8154C30.1251 12.6468 30.8021 13.3208 31.6372 13.3208Z",
    fill: "#9575CD"
  }), React.createElement("path", {
    d: "M24.4663 19.853C25.9021 19.853 27.0661 18.6943 27.0661 17.2648C27.0661 15.8354 25.9021 14.6766 24.4663 14.6766C23.0305 14.6766 21.8666 15.8354 21.8666 17.2648C21.8666 18.6943 23.0305 19.853 24.4663 19.853Z",
    fill: "#E6E9EE"
  }), React.createElement("path", {
    d: "M24.4668 18.7704C25.3019 18.7704 25.9789 18.0964 25.9789 17.265C25.9789 16.4336 25.3019 15.7596 24.4668 15.7596C23.6317 15.7596 22.9547 16.4336 22.9547 17.265C22.9547 18.0964 23.6317 18.7704 24.4668 18.7704Z",
    fill: "#9575CD"
  }), React.createElement("path", {
    d: "M17.5337 13.4264C18.9695 13.4264 20.1334 12.2676 20.1334 10.8382C20.1334 9.40878 18.9695 8.25 17.5337 8.25C16.0978 8.25 14.9339 9.40878 14.9339 10.8382C14.9339 12.2676 16.0978 13.4264 17.5337 13.4264Z",
    fill: "#E6E9EE"
  }), React.createElement("path", {
    d: "M17.5332 12.3436C18.3683 12.3436 19.0453 11.6697 19.0453 10.8383C19.0453 10.0069 18.3683 9.33289 17.5332 9.33289C16.6981 9.33289 16.0211 10.0069 16.0211 10.8383C16.0211 11.6697 16.6981 12.3436 17.5332 12.3436Z",
    fill: "#9575CD"
  }), React.createElement("path", {
    d: "M10.5922 22.1596C12.028 22.1596 13.1919 21.0008 13.1919 19.5714C13.1919 18.1419 12.028 16.9832 10.5922 16.9832C9.15638 16.9832 7.99243 18.1419 7.99243 19.5714C7.99243 21.0008 9.15638 22.1596 10.5922 22.1596Z",
    fill: "#E6E9EE"
  }), React.createElement("path", {
    d: "M10.5916 21.0769C11.4267 21.0769 12.1037 20.4029 12.1037 19.5715C12.1037 18.7401 11.4267 18.0662 10.5916 18.0662C9.75652 18.0662 9.07953 18.7401 9.07953 19.5715C9.07953 20.4029 9.75652 21.0769 10.5916 21.0769Z",
    fill: "#9575CD"
  }));
};
/* eslint-enable */

var ApiIcon = function ApiIcon(props) {
  return React.createElement("svg", _extends$1({
    width: "42",
    height: "42",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M31.9992 7H6V26.5078H31.9992V7Z",
    fill: "#E0E0E0"
  }), React.createElement("path", {
    d: "M32 7H19V26.5078H32V7Z",
    fill: "#C0C0C0"
  }), React.createElement("path", {
    d: "M31.9992 7H6V9.51027H31.9992V7Z",
    fill: "#C0C0C0"
  }), React.createElement("path", {
    d: "M32 7H19V9.51027H32V7Z",
    fill: "#929292"
  }), React.createElement("path", {
    d: "M7.5662 8.95051C7.95499 8.95051 8.27016 8.63899 8.27016 8.2547C8.27016 7.87042 7.95499 7.5589 7.5662 7.5589C7.17742 7.5589 6.86224 7.87042 6.86224 8.2547C6.86224 8.63899 7.17742 8.95051 7.5662 8.95051Z",
    fill: "#FF6838"
  }), React.createElement("path", {
    d: "M9.67796 8.95051C10.0667 8.95051 10.3819 8.63899 10.3819 8.2547C10.3819 7.87042 10.0667 7.5589 9.67796 7.5589C9.28917 7.5589 8.974 7.87042 8.974 8.2547C8.974 8.63899 9.28917 8.95051 9.67796 8.95051Z",
    fill: "#FF6838"
  }), React.createElement("path", {
    d: "M11.7897 8.95051C12.1785 8.95051 12.4937 8.63899 12.4937 8.2547C12.4937 7.87042 12.1785 7.5589 11.7897 7.5589C11.4009 7.5589 11.0858 7.87042 11.0858 8.2547C11.0858 8.63899 11.4009 8.95051 11.7897 8.95051Z",
    fill: "#FF6838"
  }), React.createElement("path", {
    d: "M7.01245 15.9904L8.9658 10.9692H9.91741L11.8636 15.9904H10.6185L10.2251 14.8659H8.64378L8.25742 15.9904H7.01245ZM9.43806 12.1997L8.82986 14.0668H10.0248L9.43806 12.1997Z",
    fill: "#005C83"
  }), React.createElement("path", {
    d: "M12.3284 15.9904V10.9692H14.4964C14.7397 10.9692 14.9626 11.0186 15.1654 11.1177C15.3681 11.2167 15.5421 11.3464 15.6877 11.5067C15.8332 11.667 15.9477 11.8485 16.0312 12.0512C16.1147 12.254 16.1564 12.4591 16.1564 12.6665C16.1564 12.8882 16.117 13.1004 16.0384 13.303C15.9597 13.5058 15.8499 13.6873 15.7092 13.8476C15.5685 14.0079 15.398 14.1352 15.1977 14.2295C14.9973 14.3238 14.7755 14.371 14.5323 14.371H13.5019V15.9905H12.3284V15.9904ZM13.5018 13.3595H14.4607C14.5989 13.3595 14.7183 13.3006 14.8184 13.1827C14.9186 13.0649 14.9686 12.8927 14.9686 12.6664C14.9686 12.5486 14.9531 12.4472 14.9221 12.3623C14.8909 12.2774 14.8493 12.2068 14.7968 12.1502C14.7443 12.0936 14.6847 12.0524 14.6179 12.0264C14.5511 12.0005 14.4844 11.9875 14.4176 11.9875H13.5017V13.3595H13.5018Z",
    fill: "#005C83"
  }), React.createElement("path", {
    d: "M16.7649 15.9904V10.9692H17.9383V15.9904H16.7649Z",
    fill: "#005C83"
  }), React.createElement("path", {
    d: "M32.7337 21.6069L33.8202 20.5204C33.199 19.6317 32.4251 18.8578 31.5365 18.2367L30.45 19.3232C29.678 18.8228 28.8108 18.4571 27.8815 18.2587V16.7215C27.3572 16.6288 26.8176 16.5803 26.2667 16.5803C25.7158 16.5803 25.1762 16.6288 24.6519 16.7215V18.2587C23.7226 18.457 22.8554 18.8228 22.0834 19.3231L20.9969 18.2366C20.1082 18.8577 19.3343 19.6316 18.7132 20.5203L19.7997 21.6068C19.2993 22.3787 18.9336 23.246 18.7352 24.1753H17.198C17.1053 24.6996 17.0568 25.2392 17.0568 25.7901C17.0568 26.341 17.1053 26.8806 17.198 27.4049H18.7352C18.9335 28.3342 19.2993 29.2014 19.7997 29.9734L18.7132 31.0599C19.3343 31.9485 20.1082 32.7224 20.9969 33.3436L22.0834 32.2571C22.8553 32.7575 23.7226 33.1232 24.6519 33.3215V34.8587C25.1762 34.9514 25.7158 35 26.2667 35C26.8176 35 27.3572 34.9514 27.8815 34.8587V33.3215C28.8108 33.1232 29.6779 32.7575 30.45 32.2571L31.5365 33.3436C32.4251 32.7224 33.199 31.9485 33.8202 31.0599L32.7337 29.9734C33.2341 29.2014 33.5998 28.3342 33.7981 27.4049H35.3353C35.428 26.8806 35.4766 26.341 35.4766 25.7901C35.4766 25.2392 35.428 24.6996 35.3353 24.1753H33.7981C33.5998 23.2461 33.2341 22.3789 32.7337 21.6069ZM26.2667 29.1916C24.3881 29.1916 22.8653 27.6687 22.8653 25.7902C22.8653 23.9116 24.3881 22.3888 26.2667 22.3888C28.1452 22.3888 29.6681 23.9116 29.6681 25.7902C29.6681 27.6687 28.1451 29.1916 26.2667 29.1916Z",
    fill: "#005C83"
  }), React.createElement("path", {
    d: "M35.3351 27.4051C35.4279 26.8808 35.4764 26.3412 35.4764 25.7902C35.4764 25.2393 35.4279 24.6997 35.3351 24.1754H33.7979C33.5997 23.2461 33.2339 22.3788 32.7336 21.6069L33.8201 20.5204C33.1989 19.6317 32.425 18.8578 31.5364 18.2367L30.4499 19.3232C29.6779 18.8228 28.8107 18.457 27.8814 18.2587V16.7215C27.3571 16.6288 26.8175 16.5803 26.2666 16.5803C26.2308 16.5803 26.1955 16.5822 26.16 16.5826V22.3914C26.1954 22.3904 26.2308 22.3888 26.2666 22.3888C28.1451 22.3888 29.668 23.9116 29.668 25.7901C29.668 27.6686 28.1452 29.1915 26.2666 29.1915C26.2308 29.1915 26.1954 29.1899 26.16 29.1888V34.9977C26.1956 34.998 26.2309 35 26.2666 35C26.8176 35 27.3571 34.9514 27.8814 34.8587V33.3215C28.8107 33.1232 29.6778 32.7575 30.4499 32.2571L31.5364 33.3436C32.425 32.7224 33.1989 31.9485 33.8201 31.0598L32.7336 29.9733C33.234 29.2013 33.5997 28.3341 33.7979 27.4048H35.3351V27.4051Z",
    fill: "#00263F"
  }));
};
/* eslint-enable */

var ApiProvisioningIcon = function ApiProvisioningIcon(props) {
  return React.createElement("svg", _extends$1({
    width: "42",
    height: "42",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M31.9992 7H6V26.5078H31.9992V7Z",
    fill: "#E0E0E0"
  }), React.createElement("path", {
    d: "M32 7H19V26.5078H32V7Z",
    fill: "#C0C0C0"
  }), React.createElement("path", {
    d: "M31.9992 7H6V9.51027H31.9992V7Z",
    fill: "#C0C0C0"
  }), React.createElement("path", {
    d: "M32 7H19V9.51027H32V7Z",
    fill: "#929292"
  }), React.createElement("path", {
    d: "M7.56623 8.95069C7.95502 8.95069 8.27019 8.63917 8.27019 8.25489C8.27019 7.8706 7.95502 7.55908 7.56623 7.55908C7.17745 7.55908 6.86227 7.8706 6.86227 8.25489C6.86227 8.63917 7.17745 8.95069 7.56623 8.95069Z",
    fill: "#FF6838"
  }), React.createElement("path", {
    d: "M9.67799 8.95069C10.0668 8.95069 10.3819 8.63917 10.3819 8.25489C10.3819 7.8706 10.0668 7.55908 9.67799 7.55908C9.2892 7.55908 8.97403 7.8706 8.97403 8.25489C8.97403 8.63917 9.2892 8.95069 9.67799 8.95069Z",
    fill: "#FF6838"
  }), React.createElement("path", {
    d: "M11.7898 8.95069C12.1786 8.95069 12.4937 8.63917 12.4937 8.25489C12.4937 7.8706 12.1786 7.55908 11.7898 7.55908C11.401 7.55908 11.0858 7.8706 11.0858 8.25489C11.0858 8.63917 11.401 8.95069 11.7898 8.95069Z",
    fill: "#FF6838"
  }), React.createElement("path", {
    d: "M7.01245 15.9905L8.9658 10.9692H9.91741L11.8636 15.9905H10.6185L10.2251 14.866H8.64378L8.25742 15.9905H7.01245ZM9.43806 12.1998L8.82986 14.0668H10.0248L9.43806 12.1998Z",
    fill: "#005C83"
  }), React.createElement("path", {
    d: "M12.3284 15.9905V10.9692H14.4964C14.7397 10.9692 14.9626 11.0187 15.1654 11.1177C15.3681 11.2168 15.5421 11.3464 15.6877 11.5067C15.8332 11.6671 15.9477 11.8486 16.0312 12.0513C16.1147 12.2541 16.1564 12.4592 16.1564 12.6666C16.1564 12.8883 16.117 13.1004 16.0384 13.3031C15.9597 13.5059 15.8499 13.6874 15.7092 13.8477C15.5685 14.008 15.398 14.1353 15.1977 14.2295C14.9973 14.3239 14.7755 14.371 14.5323 14.371H13.5019V15.9905H12.3284V15.9905ZM13.5018 13.3596H14.4607C14.5989 13.3596 14.7183 13.3007 14.8184 13.1828C14.9186 13.0649 14.9686 12.8928 14.9686 12.6665C14.9686 12.5487 14.9531 12.4472 14.9221 12.3624C14.8909 12.2775 14.8493 12.2068 14.7968 12.1502C14.7443 12.0937 14.6847 12.0525 14.6179 12.0265C14.5511 12.0006 14.4844 11.9875 14.4176 11.9875H13.5017V13.3596H13.5018Z",
    fill: "#005C83"
  }), React.createElement("path", {
    d: "M16.7649 15.9905V10.9692H17.9383V15.9905H16.7649Z",
    fill: "#005C83"
  }), React.createElement("path", {
    d: "M32.7337 21.6067L33.8202 20.5202C33.199 19.6315 32.4251 18.8576 31.5365 18.2365L30.45 19.323C29.678 18.8226 28.8108 18.4569 27.8815 18.2586V16.7214C27.3572 16.6286 26.8176 16.5801 26.2667 16.5801C25.7158 16.5801 25.1762 16.6286 24.6519 16.7214V18.2586C23.7226 18.4568 22.8554 18.8226 22.0834 19.3229L20.9969 18.2364C20.1082 18.8576 19.3343 19.6314 18.7132 20.5201L19.7997 21.6066C19.2993 22.3785 18.9336 23.2458 18.7352 24.1751H17.198C17.1053 24.6994 17.0568 25.239 17.0568 25.7899C17.0568 26.3408 17.1053 26.8804 17.198 27.4047H18.7352C18.9335 28.334 19.2993 29.2012 19.7997 29.9732L18.7132 31.0597C19.3343 31.9484 20.1082 32.7222 20.9969 33.3434L22.0834 32.2569C22.8553 32.7573 23.7226 33.123 24.6519 33.3213V34.8585C25.1762 34.9513 25.7158 34.9998 26.2667 34.9998C26.8176 34.9998 27.3572 34.9513 27.8815 34.8585V33.3213C28.8108 33.1231 29.6779 32.7573 30.45 32.2569L31.5365 33.3434C32.4251 32.7222 33.199 31.9484 33.8202 31.0597L32.7337 29.9732C33.2341 29.2012 33.5998 28.334 33.7981 27.4047H35.3353C35.428 26.8804 35.4766 26.3408 35.4766 25.7899C35.4766 25.239 35.428 24.6994 35.3353 24.1751H33.7981C33.5998 23.2459 33.2341 22.3787 32.7337 21.6067ZM26.2667 29.1914C24.3881 29.1914 22.8653 27.6685 22.8653 25.79C22.8653 23.9115 24.3881 22.3886 26.2667 22.3886C28.1452 22.3886 29.6681 23.9115 29.6681 25.79C29.6681 27.6685 28.1451 29.1914 26.2667 29.1914Z",
    fill: "#005C83"
  }), React.createElement("path", {
    d: "M35.3351 27.4049C35.4278 26.8806 35.4764 26.341 35.4764 25.79C35.4764 25.2391 35.4278 24.6995 35.3351 24.1752H33.7979C33.5996 23.2459 33.2338 22.3786 32.7335 21.6067L33.82 20.5202C33.1989 19.6315 32.425 18.8576 31.5363 18.2365L30.4498 19.323C29.6779 18.8226 28.8107 18.4568 27.8814 18.2586V16.7214C27.357 16.6286 26.8174 16.5801 26.2665 16.5801C26.2308 16.5801 26.1955 16.582 26.1599 16.5824V22.3913C26.1954 22.3902 26.2308 22.3886 26.2665 22.3886C28.1451 22.3886 29.6679 23.9114 29.6679 25.7899C29.6679 27.6684 28.1452 29.1913 26.2665 29.1913C26.2308 29.1913 26.1954 29.1897 26.1599 29.1886V34.9975C26.1956 34.9979 26.2309 34.9998 26.2665 34.9998C26.8175 34.9998 27.357 34.9513 27.8814 34.8585V33.3213C28.8107 33.1231 29.6778 32.7573 30.4498 32.2569L31.5363 33.3434C32.425 32.7222 33.1989 31.9484 33.82 31.0596L32.7335 29.9731C33.2339 29.2011 33.5996 28.3339 33.7979 27.4046H35.3351V27.4049Z",
    fill: "#00263F"
  }));
};
/* eslint-enable */

var DevicesIcon = function DevicesIcon(props) {
  return React.createElement("svg", _extends$1({
    width: "42",
    height: "42",
    fill: "none"
  }, props), React.createElement("ellipse", {
    cx: "21.1697",
    cy: "33.988",
    rx: "12.0242",
    ry: "1.01204",
    fill: "black",
    fillOpacity: "0.2"
  }), React.createElement("path", {
    d: "M13.5002 8.78838C13.5002 8.47197 13.5963 8.17836 13.7575 7.93082L9.05876 9.18063C8.20705 9.40724 7.70174 10.276 7.93002 11.1214L13.4659 31.6298C13.4711 31.6494 13.5002 31.6457 13.5002 31.6252V8.78838Z",
    fill: "#869EA2"
  }), React.createElement("path", {
    d: "M28.5001 8.32326C28.5001 8.00685 28.404 7.71324 28.2427 7.4657L32.9415 8.71551C33.7932 8.94212 34.2985 9.81085 34.0702 10.6563L28.5343 31.1647C28.5291 31.1843 28.5001 31.1805 28.5001 31.1601V8.32326Z",
    fill: "#869EA2"
  }), React.createElement("path", {
    d: "M26.9048 33.988H15.0975C14.2158 33.988 13.5009 33.2784 13.5009 32.4036V8.58455C13.5009 7.70978 14.2158 7.00018 15.0975 7.00018H26.9048C27.7865 7.00018 28.5009 7.70978 28.5009 8.58455V32.4032C28.5009 33.2784 27.7865 33.988 26.9048 33.988Z",
    fill: "#424A60"
  }), React.createElement("path", {
    d: "M28.5009 9.79196H13.5009V28.4042H28.5009V9.79196Z",
    fill: "white"
  }), React.createElement("rect", {
    x: "14.298",
    y: "13.7202",
    width: "13.4042",
    height: "2.79999",
    fill: "#38CFFF"
  }), React.createElement("rect", {
    x: "14.298",
    y: "17.3601",
    width: "13.4042",
    height: "2.79999",
    fill: "#5AE5A9"
  }), React.createElement("rect", {
    x: "14.298",
    y: "21.0001",
    width: "13.4042",
    height: "2.79999",
    fill: "#F2D90F"
  }), React.createElement("rect", {
    x: "14.298",
    y: "24.6401",
    width: "13.4042",
    height: "2.79999",
    fill: "#FD4D30"
  }), React.createElement("path", {
    d: "M21.0004 32.592C21.777 32.592 22.4066 31.967 22.4066 31.196C22.4066 30.4251 21.777 29.8001 21.0004 29.8001C20.2237 29.8001 19.5941 30.4251 19.5941 31.196C19.5941 31.967 20.2237 32.592 21.0004 32.592Z",
    fill: "#262B35"
  }), React.createElement("path", {
    d: "M21 8.86143H19.125C18.8658 8.86143 18.6562 8.65344 18.6562 8.39612C18.6562 8.13881 18.8658 7.93082 19.125 7.93082H21C21.2592 7.93082 21.4687 8.13881 21.4687 8.39612C21.4687 8.65344 21.2592 8.86143 21 8.86143Z",
    fill: "#262B35"
  }), React.createElement("path", {
    d: "M22.8749 8.86143H22.4061C22.1469 8.86143 21.9374 8.65344 21.9374 8.39612C21.9374 8.13881 22.1469 7.93082 22.4061 7.93082H22.8749C23.1341 7.93082 23.3436 8.13881 23.3436 8.39612C23.3436 8.65344 23.1341 8.86143 22.8749 8.86143Z",
    fill: "#262B35"
  }));
};
/* eslint-enable */

var EducationIcon = function EducationIcon(props) {
  return React.createElement("svg", _extends$1({
    width: "42",
    height: "42",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M12.5855 7H30.0315L33.9903 26.2203L32.5404 26.2286L32.5057 33.0145L34 33.0228L33.9902 34.1568H10.407C8.17498 33.9663 8.37407 29.6027 8.2547 28.4347L10.2417 8.89628C10.2493 8.02801 11.0708 7 12.5855 7Z",
    fill: "#20D0C2"
  }), React.createElement("path", {
    d: "M12.5857 7H14.2565L12.7357 34.1568L10.1279 34.0768C7.94712 33.9855 7.6214 28.429 8.34935 26.4145L10.2419 8.8962C10.2496 8.02801 11.071 7 12.5857 7Z",
    fill: "#FF5B61"
  }), React.createElement("path", {
    d: "M10.7108 26.2182H33.5383C32.5024 28.5459 32.5293 30.8415 33.5383 33.1065H10.7108C8.26215 33.1066 8.26249 26.2182 10.7108 26.2182Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M9.05127 28.1119H32.9276C32.9136 28.1808 32.9008 28.2498 32.8887 28.3186H9.0054C9.01968 28.2489 9.03473 28.1797 9.05127 28.1119ZM32.8158 28.8365C32.8083 28.9054 32.8019 28.9744 32.7964 29.0432H8.90127C8.90715 28.9739 8.91453 28.9049 8.92274 28.8365H32.8158ZM32.7725 29.5611C32.7715 29.6301 32.7715 29.6989 32.7725 29.7679H8.8759C8.87494 29.6989 8.87494 29.6301 8.8759 29.5611H32.7725ZM32.7968 30.2856C32.8024 30.3548 32.8088 30.4236 32.8162 30.4924H8.92308C8.91494 30.4239 8.90776 30.3549 8.90181 30.2856H32.7968ZM32.8891 31.0103C32.901 31.0791 32.914 31.1481 32.928 31.217H9.05223C9.03541 31.1489 9.02037 31.08 9.00615 31.0103H32.8891ZM33.0493 31.7347C33.0677 31.8036 33.0871 31.8726 33.1075 31.9414H9.29365C9.26438 31.8747 9.23635 31.8055 9.21023 31.7347H33.0493ZM33.2773 32.4593C33.3024 32.5283 33.3283 32.5973 33.355 32.6661H9.75378C9.69416 32.603 9.63762 32.5337 9.58395 32.4593H33.2773Z",
    fill: "#ECF0F1"
  }), React.createElement("path", {
    d: "M11.7391 29.7827H15.3063V37L13.5079 34.6455L11.7391 37V29.7827Z",
    fill: "#FF5B61"
  }), React.createElement("path", {
    d: "M13.0995 27.6624H31.485H32.5333H33.0303C33.154 27.1838 33.3223 26.7043 33.5363 26.223C33.5369 26.2214 33.5377 26.2197 33.5385 26.2182H31.9069H13.1805H10.7109C8.44511 26.2182 8.27583 32.117 10.2037 32.9973C9.55087 30.9657 10.0724 27.6624 11.7679 27.6624H13.0995Z",
    fill: "#DFE1E3"
  }), React.createElement("path", {
    d: "M19.6815 22.6293H26.5582V22.1037H19.6815V22.6293Z",
    fill: "#ECF0F1"
  }), React.createElement("path", {
    d: "M20.2349 23.6233H26.0047V23.2297H20.2349V23.6233Z",
    fill: "#ECF0F1"
  }));
};
/* eslint-enable */

/* eslint-enable */

var LegacyPortalIcon = function LegacyPortalIcon(props) {
  return React.createElement("svg", _extends$1({
    width: "42",
    height: "42",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M21.5599 27.8086H16.3331V30.5465H21.5599V27.8086Z",
    fill: "#445EA0"
  }), React.createElement("path", {
    d: "M17.6507 27.8086H16.3331V30.5465H17.6507V27.8086Z",
    fill: "#2E4C89"
  }), React.createElement("path", {
    d: "M25.0412 30.4803H12.4708C12.2844 30.4803 12.132 30.6328 12.132 30.8192V32.5172C12.132 32.7036 12.2845 32.856 12.4708 32.856H25.0412V30.4803Z",
    fill: "#293D7C"
  }), React.createElement("path", {
    d: "M13.4497 32.5171V30.819C13.4497 30.6327 13.6021 30.4802 13.7885 30.4802H12.4708C12.2844 30.4802 12.132 30.6327 12.132 30.819V32.5171C12.132 32.7034 12.2845 32.8559 12.4708 32.8559H13.7884C13.6021 32.8559 13.4497 32.7034 13.4497 32.5171Z",
    fill: "#1A2B63"
  }), React.createElement("path", {
    d: "M33.5544 7.91553H4.3388C4.15247 7.91553 4 8.068 4 8.25433V27.5363C4 27.7227 4.15247 27.8751 4.3388 27.8751H25.0412V17.7306C25.0412 17.4744 25.2497 17.2658 25.5061 17.2658H33.8932V8.25433C33.8932 8.068 33.7407 7.91553 33.5544 7.91553Z",
    fill: "#293D7C"
  }), React.createElement("path", {
    d: "M5.48724 24.4873C5.48724 24.5991 5.57869 24.6905 5.69051 24.6905H25.0412V17.7307C25.0412 17.4744 25.2497 17.2659 25.5061 17.2659H32.4059V11.2382H5.48724V24.4873Z",
    fill: "#FFFFFF"
  }), React.createElement("path", {
    d: "M6.80494 24.4873V11.2382H5.48724V24.4873C5.48724 24.5991 5.57869 24.6905 5.69051 24.6905H7.00821C6.89638 24.6905 6.80494 24.599 6.80494 24.4873Z",
    fill: "#D9EAFC"
  }), React.createElement("path", {
    d: "M18.9466 27.1913C19.4518 27.1913 19.8613 26.7818 19.8613 26.2766C19.8613 25.7715 19.4518 25.3619 18.9466 25.3619C18.4414 25.3619 18.0319 25.7715 18.0319 26.2766C18.0319 26.7818 18.4414 27.1913 18.9466 27.1913Z",
    fill: "#445EA0"
  }), React.createElement("path", {
    d: "M25.0412 18.8182H21.4935C21.3839 18.8182 21.2943 18.9079 21.2943 19.0175V22.9779C21.2943 23.0874 21.3839 23.1771 21.4935 23.1771H25.0412V18.8182Z",
    fill: "#C3DDF4"
  }), React.createElement("path", {
    d: "M22.6119 22.9779V19.0175C22.6119 18.9079 22.7015 18.8182 22.8111 18.8182H21.4935C21.3839 18.8182 21.2943 18.9079 21.2943 19.0175V22.9779C21.2943 23.0874 21.3839 23.1771 21.4935 23.1771H22.8111C22.7015 23.1771 22.6119 23.0874 22.6119 22.9779Z",
    fill: "#AEC1ED"
  }), React.createElement("path", {
    d: "M25.506 17.2658H28.6017V12.9241C28.6017 12.7415 28.4523 12.592 28.2697 12.592H9.62335C9.44073 12.592 9.29132 12.7415 9.29132 12.9241V17.3417C9.29132 17.5244 9.44073 17.6738 9.62335 17.6738H25.0451C25.0732 17.4443 25.2691 17.2658 25.506 17.2658Z",
    fill: "#C3DDF4"
  }), React.createElement("path", {
    d: "M10.609 17.3416V12.924C10.609 12.7413 10.7584 12.5919 10.941 12.5919H9.62335C9.44074 12.5919 9.29132 12.7413 9.29132 12.924V17.3416C9.29132 17.5242 9.44074 17.6737 9.62335 17.6737H10.941C10.7584 17.6737 10.609 17.5242 10.609 17.3416Z",
    fill: "#AEC1ED"
  }), React.createElement("path", {
    d: "M32.2027 9.64343H5.69051C5.57869 9.64343 5.48724 9.73487 5.48724 9.84677V11.3046H32.4059V9.84677C32.4059 9.73487 32.3144 9.64343 32.2027 9.64343Z",
    fill: "#FFAF10"
  }), React.createElement("path", {
    d: "M7.00821 9.64343H5.69051C5.57869 9.64343 5.48724 9.73487 5.48724 9.84677V11.3046H6.80488V9.84677C6.80494 9.73487 6.89638 9.64343 7.00821 9.64343Z",
    fill: "#FF9518"
  }), React.createElement("path", {
    d: "M15.3889 19.8698H9.79944C9.52438 19.8698 9.30139 19.6468 9.30139 19.3717C9.30139 19.0966 9.52438 18.8737 9.79944 18.8737H15.3889C15.6639 18.8737 15.8869 19.0966 15.8869 19.3717C15.8869 19.6468 15.6639 19.8698 15.3889 19.8698Z",
    fill: "#5DC1D8"
  }), React.createElement("path", {
    d: "M15.3889 21.4958H9.79944C9.52438 21.4958 9.30139 21.2729 9.30139 20.9978C9.30139 20.7227 9.52438 20.4998 9.79944 20.4998H15.3889C15.6639 20.4998 15.8869 20.7227 15.8869 20.9978C15.8869 21.2729 15.6639 21.4958 15.3889 21.4958Z",
    fill: "#5DC1D8"
  }), React.createElement("path", {
    d: "M15.3889 23.1219H9.79944C9.52438 23.1219 9.30139 22.899 9.30139 22.6239C9.30139 22.3488 9.52438 22.1259 9.79944 22.1259H15.3889C15.6639 22.1259 15.8869 22.3488 15.8869 22.6239C15.8869 22.899 15.6639 23.1219 15.3889 23.1219Z",
    fill: "#5DC1D8"
  }), React.createElement("path", {
    d: "M19.7754 19.8698H16.8983C16.6232 19.8698 16.4002 19.6468 16.4002 19.3717C16.4002 19.0966 16.6232 18.8737 16.8983 18.8737H19.7754C20.0504 18.8737 20.2734 19.0966 20.2734 19.3717C20.2734 19.6468 20.0504 19.8698 19.7754 19.8698Z",
    fill: "#5DC1D8"
  }), React.createElement("path", {
    d: "M19.7754 21.4958H16.8983C16.6232 21.4958 16.4002 21.2729 16.4002 20.9978C16.4002 20.7227 16.6232 20.4998 16.8983 20.4998H19.7754C20.0504 20.4998 20.2734 20.7227 20.2734 20.9978C20.2734 21.2729 20.0504 21.4958 19.7754 21.4958Z",
    fill: "#5DC1D8"
  }), React.createElement("path", {
    d: "M19.7754 23.1219H16.8983C16.6232 23.1219 16.4002 22.899 16.4002 22.6239C16.4002 22.3488 16.6232 22.1259 16.8983 22.1259H19.7754C20.0504 22.1259 20.2734 22.3488 20.2734 22.6239C20.2734 22.899 20.0504 23.1219 19.7754 23.1219Z",
    fill: "#5DC1D8"
  }), React.createElement("path", {
    d: "M37.4687 17.1993C37.7609 17.1993 38 17.4384 38 17.7306V33.7856C38 34.0778 37.7609 34.3169 37.4687 34.3169H25.506C25.2139 34.3169 24.9748 34.0778 24.9748 33.7856V17.7306C24.9748 17.4384 25.2139 17.1993 25.506 17.1993H37.4687Z",
    fill: "#445EA0"
  }), React.createElement("path", {
    d: "M26.4166 32.231C26.234 32.231 26.0846 32.0816 26.0846 31.8989V18.5549C26.0846 18.3723 26.234 18.2229 26.4166 18.2229H36.5584C36.741 18.2229 36.8904 18.3723 36.8904 18.5549V31.8989C36.8904 32.0816 36.741 32.231 36.5584 32.231H26.4166Z",
    fill: "#FFFFFF"
  }), React.createElement("path", {
    d: "M27.4022 31.8989V18.5549C27.4022 18.3723 27.5516 18.2229 27.7343 18.2229H26.4166C26.234 18.2229 26.0846 18.3723 26.0846 18.5549V31.8989C26.0846 32.0816 26.234 32.231 26.4166 32.231H27.7343C27.5516 32.231 27.4022 32.0816 27.4022 31.8989Z",
    fill: "#D9EAFC"
  }), React.createElement("path", {
    d: "M30.8658 33.5591C30.6832 33.5591 30.5338 33.4097 30.5338 33.2271V33.0979C30.5338 32.9153 30.6832 32.7659 30.8658 32.7659H32.1092C32.2918 32.7659 32.4412 32.9153 32.4412 33.0979V33.2271C32.4412 33.4097 32.2918 33.5591 32.1092 33.5591H30.8658Z",
    fill: "#445EA0"
  }), React.createElement("path", {
    d: "M36.8904 19.5041V18.5549C36.8904 18.3723 36.741 18.2229 36.5584 18.2229H26.4166C26.234 18.2229 26.0846 18.3723 26.0846 18.5549V19.5041H36.8904Z",
    fill: "#FFAF10"
  }), React.createElement("path", {
    d: "M27.7343 18.2229H26.4166C26.234 18.2229 26.0846 18.3723 26.0846 18.5549V19.5041H27.4022V18.5549C27.4022 18.3723 27.5516 18.2229 27.7343 18.2229Z",
    fill: "#FF9518"
  }), React.createElement("path", {
    d: "M33.7508 25.5776H29.2239C28.9489 25.5776 28.7259 25.3547 28.7259 25.0796C28.7259 24.8045 28.9489 24.5815 29.2239 24.5815H33.7508C34.0258 24.5815 34.2488 24.8045 34.2488 25.0796C34.2488 25.3546 34.0258 25.5776 33.7508 25.5776Z",
    fill: "#5DC1D8"
  }), React.createElement("path", {
    d: "M33.7508 27.1134H29.2239C28.9489 27.1134 28.7259 26.8905 28.7259 26.6154C28.7259 26.3403 28.9489 26.1173 29.2239 26.1173H33.7508C34.0258 26.1173 34.2488 26.3403 34.2488 26.6154C34.2488 26.8905 34.0258 27.1134 33.7508 27.1134Z",
    fill: "#5DC1D8"
  }), React.createElement("path", {
    d: "M33.7508 28.649H29.2239C28.9489 28.649 28.7259 28.4261 28.7259 28.151C28.7259 27.8759 28.9489 27.653 29.2239 27.653H33.7508C34.0258 27.653 34.2488 27.8759 34.2488 28.151C34.2488 28.4261 34.0258 28.649 33.7508 28.649Z",
    fill: "#5DC1D8"
  }), React.createElement("path", {
    d: "M35.8587 23.4077C35.8587 23.5903 35.7093 23.7397 35.5267 23.7397H27.4481C27.2654 23.7397 27.116 23.5903 27.116 23.4077V20.6688C27.116 20.4862 27.2654 20.3368 27.4481 20.3368H35.5267C35.7093 20.3368 35.8587 20.4862 35.8587 20.6688V23.4077Z",
    fill: "#C3DDF4"
  }), React.createElement("path", {
    d: "M28.4337 23.4077V20.6688C28.4337 20.4862 28.5831 20.3368 28.7657 20.3368H27.4481C27.2654 20.3368 27.116 20.4862 27.116 20.6688V23.4077C27.116 23.5903 27.2654 23.7397 27.4481 23.7397H28.7657C28.5831 23.7397 28.4337 23.5903 28.4337 23.4077Z",
    fill: "#AEC1ED"
  }), React.createElement("path", {
    d: "M34.6635 31.1877C34.6635 31.3704 34.5141 31.5198 34.3315 31.5198H28.6433C28.4607 31.5198 28.3113 31.3704 28.3113 31.1877V30.0648C28.3113 29.8822 28.4607 29.7328 28.6433 29.7328H34.3315C34.5141 29.7328 34.6635 29.8822 34.6635 30.0648V31.1877Z",
    fill: "#C3DDF4"
  }), React.createElement("path", {
    d: "M29.6289 31.1877V30.0648C29.6289 29.8822 29.7783 29.7328 29.9609 29.7328H28.6433C28.4607 29.7328 28.3113 29.8822 28.3113 30.0648V31.1877C28.3113 31.3704 28.4607 31.5198 28.6433 31.5198H29.9609C29.7783 31.5198 29.6289 31.3704 29.6289 31.1877Z",
    fill: "#AEC1ED"
  }));
};
/* eslint-enable */

var LiveIcon = function LiveIcon(props) {
  return React.createElement("svg", _extends$1({
    width: "42",
    height: "42",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M13.2725 24.816C15.2468 24.816 16.8474 26.4242 16.8474 28.4079C16.8474 30.3916 15.2468 31.9998 13.2725 31.9998C11.2981 31.9998 9.69751 30.3916 9.69751 28.4079C9.69751 26.4242 11.2981 24.816 13.2725 24.816Z",
    fill: "#1B2A38"
  }), React.createElement("path", {
    d: "M28.7646 24.8163C30.739 24.8163 32.3395 26.4244 32.3395 28.4081C32.3395 30.3919 30.739 32 28.7646 32C26.7902 32 25.1896 30.3919 25.1896 28.4081C25.1896 26.4244 26.7902 24.8163 28.7646 24.8163Z",
    fill: "#1B2A38"
  }), React.createElement("path", {
    d: "M34.424 26.6871C33.3068 29.0816 30.7373 30.5408 28.056 30.1667C27.6837 30.1293 27.3485 30.0171 27.0878 29.9048C26.2314 29.4933 24.4811 29.1565 23.066 28.932C23.066 28.932 23.066 28.932 23.066 28.8946C23.066 27.7347 22.1351 26.8367 21.0178 26.8367C19.8634 26.8367 18.9696 27.7721 18.9696 28.8946C18.9696 28.8946 18.9696 28.8946 18.9696 28.932C17.5545 29.1565 15.8043 29.4933 14.9478 29.9048C14.6871 30.0171 14.352 30.1293 13.9796 30.1667C11.2984 30.5408 8.7289 29.0443 7.61167 26.6871L4.48358 20.0271L21.0178 23.17L37.5521 20.0271L34.424 26.6871Z",
    fill: "#3F4B5B"
  }), React.createElement("path", {
    d: "M29.6204 15.0512C24.109 17.3336 17.89 17.3336 12.3786 15.0512C11.5593 17.0717 10.7028 19.092 9.88355 21.1499C16.9963 24.1058 25.0027 24.1058 32.1153 21.1499C31.2962 19.1295 30.4769 17.109 29.6204 15.0512Z",
    fill: "#1B2A38"
  }), React.createElement("path", {
    d: "M11.3734 9.99991C15.4456 9.99991 18.7468 13.3167 18.7468 17.4082C18.7468 21.4997 15.4456 24.8165 11.3734 24.8165C7.30119 24.8165 4 21.4997 4 17.4082C4 13.3167 7.30119 9.99991 11.3734 9.99991Z",
    fill: "#2B3B4E"
  }), React.createElement("path", {
    d: "M11.3733 11.7207C14.4994 11.7207 17.0337 14.267 17.0337 17.4079C17.0337 20.5489 14.4994 23.0951 11.3733 23.0951C8.24714 23.0951 5.71289 20.5489 5.71289 17.4079C5.71289 14.267 8.24714 11.7207 11.3733 11.7207Z",
    fill: "#54C0EB"
  }), React.createElement("path", {
    d: "M11.3733 13.2923C13.6356 13.2923 15.4696 15.135 15.4696 17.408C15.4696 19.681 13.6356 21.5237 11.3733 21.5237C9.11096 21.5237 7.27698 19.681 7.27698 17.408C7.27698 15.135 9.11096 13.2923 11.3733 13.2923Z",
    fill: "#84DBFF"
  }), React.createElement("path", {
    d: "M11.3734 16.6595C11.7847 16.6595 12.1182 16.9945 12.1182 17.4078C12.1182 17.8211 11.7847 18.1561 11.3734 18.1561C10.9621 18.1561 10.6286 17.8211 10.6286 17.4078C10.6286 16.9945 10.9621 16.6595 11.3734 16.6595Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M8.39468 18.493C8.99114 18.493 9.47466 18.9788 9.47466 19.5781C9.47466 20.1774 8.99114 20.6632 8.39468 20.6632C7.79822 20.6632 7.3147 20.1774 7.3147 19.5781C7.3147 18.9788 7.79822 18.493 8.39468 18.493Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M30.6266 9.99991C34.6988 9.99991 38 13.3167 38 17.4082C38 21.4997 34.6988 24.8165 30.6266 24.8165C26.5544 24.8165 23.2532 21.4997 23.2532 17.4082C23.2532 13.3167 26.5544 9.99991 30.6266 9.99991Z",
    fill: "#2B3B4E"
  }), React.createElement("path", {
    d: "M30.6257 11.7207C33.7518 11.7207 36.2861 14.267 36.2861 17.4079C36.2861 20.5489 33.7518 23.0951 30.6257 23.0951C27.4995 23.0951 24.9653 20.5489 24.9653 17.4079C24.9653 14.267 27.4995 11.7207 30.6257 11.7207Z",
    fill: "#54C0EB"
  }), React.createElement("path", {
    d: "M30.6265 13.2923C32.8888 13.2923 34.7228 15.135 34.7228 17.408C34.7228 19.681 32.8888 21.5237 30.6265 21.5237C28.3641 21.5237 26.5302 19.681 26.5302 17.408C26.5302 15.135 28.3641 13.2923 30.6265 13.2923Z",
    fill: "#84DBFF"
  }), React.createElement("path", {
    d: "M30.6261 16.6595C31.0375 16.6595 31.3709 16.9945 31.3709 17.4078C31.3709 17.8211 31.0375 18.1561 30.6261 18.1561C30.2148 18.1561 29.8813 17.8211 29.8813 17.4078C29.8813 16.9945 30.2148 16.6595 30.6261 16.6595Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M27.6466 18.493C28.2431 18.493 28.7266 18.9788 28.7266 19.5781C28.7266 20.1774 28.2431 20.6632 27.6466 20.6632C27.0502 20.6632 26.5667 20.1774 26.5667 19.5781C26.5667 18.9788 27.0502 18.493 27.6466 18.493Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M21.0178 18.1563C22.1695 18.1563 23.1032 19.0944 23.1032 20.2516C23.1032 21.4087 22.1695 22.3468 21.0178 22.3468C19.8661 22.3468 18.9324 21.4087 18.9324 20.2516C18.9324 19.0944 19.8661 18.1563 21.0178 18.1563Z",
    fill: "#324A5E"
  }), React.createElement("path", {
    d: "M21.0182 18.7927C21.8203 18.7927 22.4705 19.446 22.4705 20.2519C22.4705 21.0578 21.8203 21.7111 21.0182 21.7111C20.2161 21.7111 19.5659 21.0578 19.5659 20.2519C19.5659 19.446 20.2161 18.7927 21.0182 18.7927Z",
    fill: "#2B3B4E"
  }), React.createElement("path", {
    d: "M23.9606 27.9968C23.2531 25.9389 21.0187 25.8641 21.0187 25.8641C21.0187 25.8641 18.7471 25.939 18.0768 27.9968L17.0341 28.1838V24.143H21.0187H25.0033V28.1838L23.9606 27.9968Z",
    fill: "#1B2A38"
  }));
};
/* eslint-enable */

var NetworkDiagramIcon = function NetworkDiagramIcon(props) {
  return React.createElement("svg", _extends$1({
    width: "42",
    height: "42",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M22.7528 33.236L22.5206 31.6114C27.7332 30.868 31.7187 26.2197 31.7187 20.9454C31.7187 15.671 27.7332 11.1322 22.5206 10.3888L22.7528 8.76416C28.7682 9.62292 33.3594 14.8595 33.3594 20.9454C33.3594 27.0313 28.7682 32.3772 22.7528 33.236Z",
    fill: "#465A61"
  }), React.createElement("path", {
    d: "M19.2472 33.236C13.2318 32.3772 8.64062 27.0313 8.64062 20.9454C8.64062 14.8595 13.2318 9.62292 19.2472 8.76416L19.4794 10.3888C14.2668 11.1322 10.2812 15.671 10.2812 20.9454C10.2812 26.2197 14.2668 30.868 19.4794 31.6114L19.2472 33.236Z",
    fill: "#596C76"
  }), React.createElement("path", {
    d: "M11.1016 31.7188H19.3594V33.3594H11.1016V31.7188Z",
    fill: "#596C76"
  }), React.createElement("path", {
    d: "M22.6406 31.7188H30.8984V33.3594H22.6406V31.7188Z",
    fill: "#465A61"
  }), React.createElement("path", {
    d: "M11.1016 8.64062H19.3594V10.2812H11.1016V8.64062Z",
    fill: "#596C76"
  }), React.createElement("path", {
    d: "M22.6406 8.64062H30.8984V10.2812H22.6406V8.64062Z",
    fill: "#465A61"
  }), React.createElement("path", {
    d: "M28.4375 16.8438L24.6914 17.2539L21 20.9453L19.3594 24.5923L21 29.2578L28.4375 25.1562V16.8438Z",
    fill: "#FF641A"
  }), React.createElement("path", {
    d: "M13.5625 16.8438L17.8702 17.5658L21 20.9453V29.2578L13.5625 25.1562V16.8438Z",
    fill: "#FFD400"
  }), React.createElement("path", {
    d: "M28.4375 16.8438L21 20.9453L13.5625 16.8438L21 12.7422L28.4375 16.8438Z",
    fill: "#FF9F04"
  }), React.createElement("path", {
    d: "M28.4375 16.8438L21 20.9453V12.7422L28.4375 16.8438Z",
    fill: "#FF9F04"
  }), React.createElement("path", {
    d: "M21 7C19.6382 7 18.5391 8.09909 18.5391 9.46094C18.5391 10.8228 19.6382 11.9219 21 11.9219C22.3618 11.9219 23.4609 10.8228 23.4609 9.46094C23.4609 8.09909 22.3618 7 21 7Z",
    fill: "#FFDA2D"
  }), React.createElement("path", {
    d: "M21 30.0781C19.6382 30.0781 18.5391 31.1772 18.5391 32.5391C18.5391 33.9009 19.6382 35 21 35C22.3618 35 23.4609 33.9009 23.4609 32.5391C23.4609 31.1772 22.3618 30.0781 21 30.0781Z",
    fill: "#FFDA2D"
  }), React.createElement("path", {
    d: "M35 35H30.0781V30.0781H35V35Z",
    fill: "#FDBF00"
  }), React.createElement("path", {
    d: "M11.9219 35H7V30.0781H11.9219V35Z",
    fill: "#FFDA2D"
  }), React.createElement("path", {
    d: "M11.9219 11.9219H7V7H11.9219V11.9219Z",
    fill: "#FFDA2D"
  }), React.createElement("path", {
    d: "M35 11.9219H30.0781V7H35V11.9219Z",
    fill: "#FDBF00"
  }), React.createElement("path", {
    d: "M23.4609 32.5391C23.4609 33.9009 22.3618 35 21 35V30.0781C22.3618 30.0781 23.4609 31.1772 23.4609 32.5391Z",
    fill: "#FDBF00"
  }), React.createElement("path", {
    d: "M21 11.9219V7C22.3618 7 23.4609 8.09909 23.4609 9.46094C23.4609 10.8228 22.3618 11.9219 21 11.9219Z",
    fill: "#FDBF00"
  }));
};
/* eslint-enable */

var PrepaidPassManagerIcon = function PrepaidPassManagerIcon(props) {
  return React.createElement("svg", _extends$1({
    width: "42",
    height: "42",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6122 2.24121L26.6943 3.04529C27.0228 6.26114 27.0789 9.20882 26.256 11.2693C25.7834 12.4529 25.0261 13.6826 24.1617 14.5724C23.3229 15.4357 22.2615 16.0984 21.2069 15.8371C20.1131 15.566 19.6283 14.4645 19.5606 13.2748C19.4911 12.0552 19.8326 10.565 20.5726 9.17553C21.6889 7.07923 22.8622 5.61539 26.0085 2.78445L26.6122 2.24121ZM25.953 3.94151C23.3043 6.37686 22.2834 7.71005 21.3003 9.55619C20.6186 10.8362 20.3224 12.1799 20.3821 13.2289C20.4435 14.3077 20.8546 14.9092 21.4065 15.0459C21.9977 15.1924 22.7637 14.8356 23.5689 14.0067C24.3485 13.2043 25.0517 12.069 25.4909 10.9692C26.1683 9.27305 26.2042 6.81791 25.953 3.94151Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    d: "M14.1889 11.1191H19.8057C19.6052 11.8776 19.5228 12.6157 19.5603 13.2747C19.5626 13.316 19.5655 13.3572 19.5689 13.3983C18.861 13.8086 18.3853 14.5699 18.3853 15.4414C18.3853 16.7475 19.4537 17.8064 20.7716 17.8064C22.0895 17.8064 23.1578 16.7475 23.1578 15.4414C23.1578 14.1353 22.0895 13.0764 20.7716 13.0764C20.637 13.0764 20.505 13.0874 20.3766 13.1086C20.3583 12.5121 20.4509 11.8283 20.6594 11.1191H27.3543C28.2632 11.1191 29 11.8494 29 12.7502V36.6449C29 37.5457 28.2632 38.276 27.3543 38.276H14.1889C13.2799 38.276 12.5432 37.5457 12.5432 36.6449V12.7502C12.5432 11.8494 13.2799 11.1191 14.1889 11.1191Z",
    fill: "#F86E51"
  }), React.createElement("path", {
    d: "M17.8918 22.5362C17.8918 22.2659 18.1128 22.0469 18.3855 22.0469H23.158C23.4306 22.0469 23.6517 22.2659 23.6517 22.5362C23.6517 22.8064 23.4306 23.0255 23.158 23.0255H18.3855C18.1128 23.0255 17.8918 22.8064 17.8918 22.5362Z",
    fill: "#565464"
  }), React.createElement("path", {
    d: "M15.5054 24.9835C15.5054 24.7132 15.7265 24.4941 15.9991 24.4941H25.5441C25.8168 24.4941 26.0378 24.7132 26.0378 24.9835C26.0378 25.2537 25.8168 25.4728 25.5441 25.4728H15.9991C15.7265 25.4728 15.5054 25.2537 15.5054 24.9835Z",
    fill: "#565464"
  }), React.createElement("path", {
    d: "M13.5304 30.8551C13.5304 30.1345 14.1198 29.5503 14.847 29.5503H26.6959C27.423 29.5503 28.0124 30.1345 28.0124 30.8551V35.3405C28.0124 36.0611 27.423 36.6453 26.6959 36.6453H14.847C14.1198 36.6453 13.5304 36.0611 13.5304 35.3405V30.8551Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M15.9168 30.773C15.9168 30.6379 16.0273 30.5283 16.1636 30.5283C16.3 30.5283 16.4105 30.6379 16.4105 30.773V34.3613C16.4105 34.4964 16.3 34.6059 16.1636 34.6059C16.0273 34.6059 15.9168 34.4964 15.9168 34.3613V30.773Z",
    fill: "#5B5869"
  }), React.createElement("path", {
    d: "M17.0688 30.773C17.0688 30.6379 17.1793 30.5283 17.3156 30.5283C17.4519 30.5283 17.5625 30.6379 17.5625 30.773V34.3613C17.5625 34.4964 17.4519 34.6059 17.3156 34.6059C17.1793 34.6059 17.0688 34.4964 17.0688 34.3613V30.773Z",
    fill: "#5B5869"
  }), React.createElement("path", {
    d: "M18.2207 30.773C18.2207 30.6379 18.3313 30.5283 18.4676 30.5283C18.6039 30.5283 18.7144 30.6379 18.7144 30.773V34.3613C18.7144 34.4964 18.6039 34.6059 18.4676 34.6059C18.3313 34.6059 18.2207 34.4964 18.2207 34.3613V30.773Z",
    fill: "#5B5869"
  }), React.createElement("path", {
    d: "M19.3727 30.773C19.3727 30.6379 19.4832 30.5283 19.6196 30.5283C19.7559 30.5283 19.8664 30.6379 19.8664 30.773V34.3613C19.8664 34.4964 19.7559 34.6059 19.6196 34.6059C19.4832 34.6059 19.3727 34.4964 19.3727 34.3613V30.773Z",
    fill: "#5B5869"
  }), React.createElement("path", {
    d: "M20.5247 30.773C20.5247 30.6379 20.6352 30.5283 20.7715 30.5283C20.9079 30.5283 21.0184 30.6379 21.0184 30.773V34.3613C21.0184 34.4964 20.9079 34.6059 20.7715 34.6059C20.6352 34.6059 20.5247 34.4964 20.5247 34.3613V30.773Z",
    fill: "#5B5869"
  }), React.createElement("path", {
    d: "M21.6767 30.773C21.6767 30.6379 21.7872 30.5283 21.9235 30.5283C22.0599 30.5283 22.1704 30.6379 22.1704 30.773V34.3613C22.1704 34.4964 22.0599 34.6059 21.9235 34.6059C21.7872 34.6059 21.6767 34.4964 21.6767 34.3613V30.773Z",
    fill: "#5B5869"
  }), React.createElement("path", {
    d: "M22.8286 30.773C22.8286 30.6379 22.9392 30.5283 23.0755 30.5283C23.2118 30.5283 23.3224 30.6379 23.3224 30.773V34.3613C23.3224 34.4964 23.2118 34.6059 23.0755 34.6059C22.9392 34.6059 22.8286 34.4964 22.8286 34.3613V30.773Z",
    fill: "#5B5869"
  }), React.createElement("path", {
    d: "M23.9806 30.773C23.9806 30.6379 24.0911 30.5283 24.2275 30.5283C24.3638 30.5283 24.4743 30.6379 24.4743 30.773V34.3613C24.4743 34.4964 24.3638 34.6059 24.2275 34.6059C24.0911 34.6059 23.9806 34.4964 23.9806 34.3613V30.773Z",
    fill: "#5B5869"
  }), React.createElement("path", {
    d: "M25.1326 30.773C25.1326 30.6379 25.2431 30.5283 25.3795 30.5283C25.5158 30.5283 25.6263 30.6379 25.6263 30.773V34.3613C25.6263 34.4964 25.5158 34.6059 25.3795 34.6059C25.2431 34.6059 25.1326 34.4964 25.1326 34.3613V30.773Z",
    fill: "#5B5869"
  }), React.createElement("path", {
    d: "M14.7648 30.773C14.7648 30.6379 14.8753 30.5283 15.0117 30.5283C15.148 30.5283 15.2585 30.6379 15.2585 30.773V35.4214C15.2585 35.5566 15.148 35.6661 15.0117 35.6661C14.8753 35.6661 14.7648 35.5566 14.7648 35.4214V30.773Z",
    fill: "#5B5869"
  }), React.createElement("path", {
    d: "M26.2846 30.773C26.2846 30.6379 26.3951 30.5283 26.5314 30.5283C26.6678 30.5283 26.7783 30.6379 26.7783 30.773V35.4214C26.7783 35.5566 26.6678 35.6661 26.5314 35.6661C26.3951 35.6661 26.2846 35.5566 26.2846 35.4214V30.773Z",
    fill: "#5B5869"
  }));
};
/* eslint-enable */

var SchedulerIcon = function SchedulerIcon(props) {
  return React.createElement("svg", _extends$1({
    width: "42",
    height: "42",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M37.7586 35.2758H4.24137C3.55575 35.2758 3 34.72 3 34.0344V5.4827C3 4.79708 3.55575 4.24133 4.24137 4.24133H37.7586C38.4443 4.24133 39 4.79708 39 5.4827V34.0344C39 34.72 38.4442 35.2758 37.7586 35.2758Z",
    fill: "#EFF2FA"
  }), React.createElement("path", {
    d: "M29.5909 35.2761C30.4378 33.8142 30.9304 32.1216 30.9304 30.3105C30.9304 24.8258 26.4841 20.3795 20.9994 20.3795C15.5146 20.3795 11.0684 24.8258 11.0684 30.3105C11.0684 32.1216 11.561 33.8141 12.4078 35.2761H29.5909Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M39 10.4482H3V5.4827C3 4.79708 3.55575 4.24133 4.24137 4.24133H37.7586C38.4443 4.24133 39 4.79708 39 5.4827V10.4482Z",
    fill: "#FF6464"
  }), React.createElement("path", {
    d: "M39 10.4483H3V11.6897H39V10.4483Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M8.27645 8.89696C9.30485 8.89696 10.1385 8.06328 10.1385 7.03488C10.1385 6.00648 9.30485 5.17279 8.27645 5.17279C7.24805 5.17279 6.41437 6.00648 6.41437 7.03488C6.41437 8.06328 7.24805 8.89696 8.27645 8.89696Z",
    fill: "#D2555A"
  }), React.createElement("path", {
    d: "M8.27616 7.96554C7.76197 7.96554 7.34515 7.54866 7.34515 7.03453V3.93101C7.34515 3.41688 7.76204 3 8.27616 3C8.79036 3 9.20717 3.41688 9.20717 3.93101V7.03446C9.20724 7.54866 8.79036 7.96554 8.27616 7.96554Z",
    fill: "#C7CFE2"
  }), React.createElement("path", {
    d: "M8.27616 6.1038C7.76197 6.1038 7.34515 5.68692 7.34515 5.17279V7.03488C7.34515 7.54907 7.76204 7.96588 8.27616 7.96588C8.79036 7.96588 9.20717 7.549 9.20717 7.03488V5.17279C9.20724 5.68692 8.79036 6.1038 8.27616 6.1038Z",
    fill: "#AFB9D2"
  }), React.createElement("path", {
    d: "M33.7245 8.89696C34.7529 8.89696 35.5866 8.06328 35.5866 7.03488C35.5866 6.00648 34.7529 5.17279 33.7245 5.17279C32.6961 5.17279 31.8624 6.00648 31.8624 7.03488C31.8624 8.06328 32.6961 8.89696 33.7245 8.89696Z",
    fill: "#D2555A"
  }), React.createElement("path", {
    d: "M33.7234 7.96554C33.2092 7.96554 32.7924 7.54866 32.7924 7.03453V3.93101C32.7923 3.41688 33.2092 3 33.7234 3C34.2376 3 34.6544 3.41688 34.6544 3.93101V7.03446C34.6544 7.54866 34.2376 7.96554 33.7234 7.96554Z",
    fill: "#C7CFE2"
  }), React.createElement("path", {
    d: "M33.7234 6.1038C33.2092 6.1038 32.7924 5.68692 32.7924 5.17279V7.03488C32.7924 7.54907 33.2093 7.96588 33.7234 7.96588C34.2376 7.96588 34.6544 7.549 34.6544 7.03488V5.17279C34.6544 5.68692 34.2376 6.1038 33.7234 6.1038Z",
    fill: "#AFB9D2"
  }), React.createElement("path", {
    d: "M9.82751 19.138H7.34478C7.00201 19.138 6.72406 18.8601 6.72406 18.5173V16.6552C6.72406 16.3124 7.00201 16.0345 7.34478 16.0345H9.82751C10.1703 16.0345 10.4482 16.3124 10.4482 16.6552V18.5173C10.4482 18.8601 10.1703 19.138 9.82751 19.138Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M14.7933 19.1379H12.3106C11.9678 19.1379 11.6899 18.8599 11.6899 18.5172V16.6551C11.6899 16.3123 11.9678 16.0344 12.3106 16.0344H14.7933C15.1361 16.0344 15.4141 16.3123 15.4141 16.6551V18.5172C15.4141 18.86 15.1361 19.1379 14.7933 19.1379Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M19.7587 19.1379H17.276C16.9332 19.1379 16.6553 18.8599 16.6553 18.5172V16.6551C16.6553 16.3123 16.9332 16.0344 17.276 16.0344H19.7587C20.1015 16.0344 20.3794 16.3123 20.3794 16.6551V18.5172C20.3794 18.86 20.1015 19.1379 19.7587 19.1379Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M24.7241 19.1379H22.2414C21.8986 19.1379 21.6207 18.8599 21.6207 18.5172V16.6551C21.6207 16.3123 21.8986 16.0344 22.2414 16.0344H24.7241C25.0669 16.0344 25.3448 16.3123 25.3448 16.6551V18.5172C25.3448 18.86 25.0669 19.1379 24.7241 19.1379Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M29.6899 19.138H27.2072C26.8644 19.138 26.5865 18.8601 26.5865 18.5173V16.6552C26.5865 16.3124 26.8644 16.0345 27.2072 16.0345H29.6899C30.0327 16.0345 30.3107 16.3124 30.3107 16.6552V18.5173C30.3107 18.8601 30.0327 19.138 29.6899 19.138Z",
    fill: "#D7DEED"
  }), React.createElement("path", {
    d: "M34.6541 19.1379H32.1714C31.8286 19.1379 31.5507 18.8599 31.5507 18.5172V16.6551C31.5507 16.3123 31.8286 16.0344 32.1714 16.0344H34.6541C34.9969 16.0344 35.2748 16.3123 35.2748 16.6551V18.5172C35.2748 18.86 34.9969 19.1379 34.6541 19.1379Z",
    fill: "#D7DEED"
  }), React.createElement("path", {
    d: "M9.82751 14.7936H7.34478C7.00201 14.7936 6.72406 14.5156 6.72406 14.1728C6.72406 13.8301 7.00201 13.5521 7.34478 13.5521H9.82751C10.1703 13.5521 10.4482 13.8301 10.4482 14.1728C10.4482 14.5157 10.1703 14.7936 9.82751 14.7936Z",
    fill: "#C7CFE2"
  }), React.createElement("path", {
    d: "M14.7933 14.7931H12.3106C11.9678 14.7931 11.6899 14.5151 11.6899 14.1724C11.6899 13.8296 11.9678 13.5516 12.3106 13.5516H14.7933C15.1361 13.5516 15.4141 13.8296 15.4141 14.1724C15.4141 14.5152 15.1361 14.7931 14.7933 14.7931Z",
    fill: "#C7CFE2"
  }), React.createElement("path", {
    d: "M19.7587 14.7931H17.276C16.9332 14.7931 16.6553 14.5151 16.6553 14.1724C16.6553 13.8296 16.9332 13.5516 17.276 13.5516H19.7587C20.1015 13.5516 20.3794 13.8296 20.3794 14.1724C20.3794 14.5152 20.1015 14.7931 19.7587 14.7931Z",
    fill: "#C7CFE2"
  }), React.createElement("path", {
    d: "M24.7241 14.7931H22.2414C21.8986 14.7931 21.6207 14.5151 21.6207 14.1724C21.6207 13.8296 21.8986 13.5516 22.2414 13.5516H24.7241C25.0669 13.5516 25.3448 13.8296 25.3448 14.1724C25.3448 14.5152 25.0669 14.7931 24.7241 14.7931Z",
    fill: "#C7CFE2"
  }), React.createElement("path", {
    d: "M29.6899 14.7936H27.2072C26.8644 14.7936 26.5865 14.5156 26.5865 14.1728C26.5865 13.8301 26.8644 13.5521 27.2072 13.5521H29.6899C30.0327 13.5521 30.3107 13.8301 30.3107 14.1728C30.3107 14.5157 30.0327 14.7936 29.6899 14.7936Z",
    fill: "#FF6464"
  }), React.createElement("path", {
    d: "M34.6541 14.7931H32.1714C31.8286 14.7931 31.5507 14.5151 31.5507 14.1724C31.5507 13.8296 31.8286 13.5516 32.1714 13.5516H34.6541C34.9969 13.5516 35.2748 13.8296 35.2748 14.1724C35.2748 14.5152 34.9969 14.7931 34.6541 14.7931Z",
    fill: "#FF6464"
  }), React.createElement("path", {
    d: "M9.82751 23.4836H7.34478C7.00201 23.4836 6.72406 23.2056 6.72406 22.8629V21.0008C6.72406 20.6581 7.00201 20.3801 7.34478 20.3801H9.82751C10.1703 20.3801 10.4482 20.6581 10.4482 21.0008V22.8629C10.4482 23.2057 10.1703 23.4836 9.82751 23.4836Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M14.7933 23.4829H12.3106C11.9678 23.4829 11.6899 23.205 11.6899 22.8622V21.0002C11.6899 20.6574 11.9678 20.3795 12.3106 20.3795H14.7933C15.1361 20.3795 15.4141 20.6574 15.4141 21.0002V22.8623C15.4141 23.205 15.1361 23.4829 14.7933 23.4829Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M19.7587 23.4829H17.276C16.9332 23.4829 16.6553 23.205 16.6553 22.8622V21.0002C16.6553 20.6574 16.9332 20.3795 17.276 20.3795H19.7587C20.1015 20.3795 20.3794 20.6574 20.3794 21.0002V22.8623C20.3794 23.205 20.1015 23.4829 19.7587 23.4829Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M24.7241 23.4829H22.2414C21.8986 23.4829 21.6207 23.205 21.6207 22.8622V21.0002C21.6207 20.6574 21.8986 20.3795 22.2414 20.3795H24.7241C25.0669 20.3795 25.3448 20.6574 25.3448 21.0002V22.8623C25.3448 23.205 25.0669 23.4829 24.7241 23.4829Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M29.6899 23.4836H27.2072C26.8644 23.4836 26.5865 23.2056 26.5865 22.8629V21.0008C26.5865 20.6581 26.8644 20.3801 27.2072 20.3801H29.6899C30.0327 20.3801 30.3107 20.6581 30.3107 21.0008V22.8629C30.3107 23.2057 30.0327 23.4836 29.6899 23.4836Z",
    fill: "#D7DEED"
  }), React.createElement("path", {
    d: "M34.6541 23.4829H32.1714C31.8286 23.4829 31.5507 23.205 31.5507 22.8622V21.0002C31.5507 20.6574 31.8286 20.3795 32.1714 20.3795H34.6541C34.9969 20.3795 35.2748 20.6574 35.2748 21.0002V22.8623C35.2748 23.205 34.9969 23.4829 34.6541 23.4829Z",
    fill: "#D7DEED"
  }), React.createElement("path", {
    d: "M9.82751 27.828H7.34478C7.00201 27.828 6.72406 27.5501 6.72406 27.2073V25.3452C6.72406 25.0024 7.00201 24.7245 7.34478 24.7245H9.82751C10.1703 24.7245 10.4482 25.0024 10.4482 25.3452V27.2073C10.4482 27.5501 10.1703 27.828 9.82751 27.828Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M14.7933 27.8275H12.3106C11.9678 27.8275 11.6899 27.5496 11.6899 27.2068V25.3447C11.6899 25.0019 11.9678 24.724 12.3106 24.724H14.7933C15.1361 24.724 15.4141 25.0019 15.4141 25.3447V27.2068C15.4141 27.5496 15.1361 27.8275 14.7933 27.8275Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M19.7587 27.8275H17.276C16.9332 27.8275 16.6553 27.5496 16.6553 27.2068V25.3447C16.6553 25.0019 16.9332 24.724 17.276 24.724H19.7587C20.1015 24.724 20.3794 25.0019 20.3794 25.3447V27.2068C20.3794 27.5496 20.1015 27.8275 19.7587 27.8275Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M24.7241 27.8275H22.2414C21.8986 27.8275 21.6207 27.5496 21.6207 27.2068V25.3447C21.6207 25.0019 21.8986 24.724 22.2414 24.724H24.7241C25.0669 24.724 25.3448 25.0019 25.3448 25.3447V27.2068C25.3448 27.5496 25.0669 27.8275 24.7241 27.8275Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M29.6899 27.828H27.2072C26.8644 27.828 26.5865 27.5501 26.5865 27.2073V25.3452C26.5865 25.0024 26.8644 24.7245 27.2072 24.7245H29.6899C30.0327 24.7245 30.3107 25.0024 30.3107 25.3452V27.2073C30.3107 27.5501 30.0327 27.828 29.6899 27.828Z",
    fill: "#D7DEED"
  }), React.createElement("path", {
    d: "M34.6541 27.8275H32.1714C31.8286 27.8275 31.5507 27.5496 31.5507 27.2068V25.3447C31.5507 25.0019 31.8286 24.724 32.1714 24.724H34.6541C34.9969 24.724 35.2748 25.0019 35.2748 25.3447V27.2068C35.2748 27.5496 34.9969 27.8275 34.6541 27.8275Z",
    fill: "#D7DEED"
  }), React.createElement("path", {
    d: "M9.82751 32.1727H7.34478C7.00201 32.1727 6.72406 31.8947 6.72406 31.552V29.6899C6.72406 29.3471 7.00201 29.0692 7.34478 29.0692H9.82751C10.1703 29.0692 10.4482 29.3471 10.4482 29.6899V31.552C10.4482 31.8947 10.1703 32.1727 9.82751 32.1727Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M14.7933 32.1724H12.3106C11.9678 32.1724 11.6899 31.8945 11.6899 31.5517V29.6896C11.6899 29.3469 11.9678 29.0689 12.3106 29.0689H14.7933C15.1361 29.0689 15.4141 29.3469 15.4141 29.6896V31.5517C15.4141 31.8945 15.1361 32.1724 14.7933 32.1724Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M19.7587 32.1724H17.276C16.9332 32.1724 16.6553 31.8945 16.6553 31.5517V29.6896C16.6553 29.3469 16.9332 29.0689 17.276 29.0689H19.7587C20.1015 29.0689 20.3794 29.3469 20.3794 29.6896V31.5517C20.3794 31.8945 20.1015 32.1724 19.7587 32.1724Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M24.7241 32.1724H22.2414C21.8986 32.1724 21.6207 31.8945 21.6207 31.5517V29.6896C21.6207 29.3469 21.8986 29.0689 22.2414 29.0689H24.7241C25.0669 29.0689 25.3448 29.3469 25.3448 29.6896V31.5517C25.3448 31.8945 25.0669 32.1724 24.7241 32.1724Z",
    fill: "#E4EAF6"
  }), React.createElement("path", {
    d: "M29.6899 32.1727H27.2072C26.8644 32.1727 26.5865 31.8947 26.5865 31.552V29.6899C26.5865 29.3471 26.8644 29.0692 27.2072 29.0692H29.6899C30.0327 29.0692 30.3107 29.3471 30.3107 29.6899V31.552C30.3107 31.8947 30.0327 32.1727 29.6899 32.1727Z",
    fill: "#D7DEED"
  }), React.createElement("path", {
    d: "M34.6541 32.1724H32.1714C31.8286 32.1724 31.5507 31.8945 31.5507 31.5517V29.6896C31.5507 29.3469 31.8286 29.0689 32.1714 29.0689H34.6541C34.9969 29.0689 35.2748 29.3469 35.2748 29.6896V31.5517C35.2748 31.8945 34.9969 32.1724 34.6541 32.1724Z",
    fill: "#D7DEED"
  }), React.createElement("path", {
    d: "M21.0002 38.9999C25.7993 38.9999 29.6898 35.1095 29.6898 30.3103C29.6898 25.5112 25.7993 21.6207 21.0002 21.6207C16.201 21.6207 12.3105 25.5112 12.3105 30.3103C12.3105 35.1095 16.201 38.9999 21.0002 38.9999Z",
    fill: "#AFB9D2"
  }), React.createElement("path", {
    d: "M21.0002 37.7588C25.1137 37.7588 28.4484 34.4241 28.4484 30.3105C28.4484 26.1969 25.1137 22.8622 21.0002 22.8622C16.8866 22.8622 13.5519 26.1969 13.5519 30.3105C13.5519 34.4241 16.8866 37.7588 21.0002 37.7588Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M21.0005 34.6553C23.4001 34.6553 25.3453 32.71 25.3453 30.3105C25.3453 27.9109 23.4001 25.9656 21.0005 25.9656C18.6009 25.9656 16.6557 27.9109 16.6557 30.3105C16.6557 32.71 18.6009 34.6553 21.0005 34.6553Z",
    fill: "#EFF2FA"
  }), React.createElement("path", {
    d: "M20.9998 22.2416C20.657 22.2416 20.3791 22.5196 20.3791 22.8624V23.4831C20.3791 23.8258 20.657 24.1038 20.9998 24.1038C21.3426 24.1038 21.6205 23.8258 21.6205 23.4831V22.8624C21.6205 22.5196 21.3426 22.2416 20.9998 22.2416Z",
    fill: "#707487"
  }), React.createElement("path", {
    d: "M20.9998 36.5176C20.657 36.5176 20.3791 36.7955 20.3791 37.1383V37.759C20.3791 38.1018 20.657 38.3797 20.9998 38.3797C21.3426 38.3797 21.6205 38.1018 21.6205 37.759V37.1383C21.6205 36.7955 21.3426 36.5176 20.9998 36.5176Z",
    fill: "#707487"
  }), React.createElement("path", {
    d: "M29.0691 30.3107C29.0691 29.9679 28.7911 29.6899 28.4483 29.6899H27.8276C27.4849 29.6899 27.2069 29.9679 27.2069 30.3107C27.2069 30.6534 27.4849 30.9314 27.8276 30.9314H28.4483C28.7911 30.9313 29.0691 30.6534 29.0691 30.3107Z",
    fill: "#707487"
  }), React.createElement("path", {
    d: "M14.7931 30.3107C14.7931 29.9679 14.5152 29.6899 14.1724 29.6899H13.5517C13.2089 29.6899 12.931 29.9679 12.931 30.3107C12.931 30.6534 13.2089 30.9314 13.5517 30.9314H14.1724C14.5153 30.9313 14.7931 30.6534 14.7931 30.3107Z",
    fill: "#707487"
  }), React.createElement("path", {
    d: "M20.9994 32.7931C20.6566 32.7931 20.3787 32.5151 20.3787 32.1724V25.9654C20.3787 25.6227 20.6566 25.3447 20.9994 25.3447C21.3422 25.3447 21.6201 25.6227 21.6201 25.9654V32.1724C21.6201 32.5152 21.3422 32.7931 20.9994 32.7931Z",
    fill: "#5B5D6E"
  }), React.createElement("path", {
    d: "M18.517 30.3104C18.517 29.9676 18.795 29.6896 19.1377 29.6896H25.3447C25.6874 29.6896 25.9654 29.9676 25.9654 30.3104C25.9654 30.6531 25.6874 30.9311 25.3447 30.9311H19.1377C18.7949 30.931 18.517 30.6531 18.517 30.3104Z",
    fill: "#5B5D6E"
  }), React.createElement("path", {
    d: "M21 31.5517C21.6856 31.5517 22.2414 30.9959 22.2414 30.3103C22.2414 29.6247 21.6856 29.069 21 29.069C20.3144 29.069 19.7587 29.6247 19.7587 30.3103C19.7587 30.9959 20.3144 31.5517 21 31.5517Z",
    fill: "#C7CFE2"
  }));
};
/* eslint-enable */

var UsersIcon = function UsersIcon(props) {
  return React.createElement("svg", _extends$1({
    width: "42",
    height: "42",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M8 6.23077C8 5.55104 8.55103 5 9.23077 5H32.1231C32.8028 5 33.3538 5.55103 33.3538 6.23077V35.7692C33.3538 36.449 32.8028 37 32.1231 37H9.23077C8.55103 37 8 36.449 8 35.7692V6.23077Z",
    fill: "#F7F7F7"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6769 10.1689C13.2209 10.1689 13.6615 9.72832 13.6615 9.18432C13.6615 8.64032 13.2209 8.19971 12.6769 8.19971C12.1329 8.19971 11.6923 8.64032 11.6923 9.18432C11.6923 9.72832 12.1329 10.1689 12.6769 10.1689V10.1689ZM12.6769 10.6612C12.0196 10.6612 10.7076 10.9911 10.7076 11.6459V12.1382H14.6461V11.6459C14.6461 10.9911 13.3341 10.6612 12.6769 10.6612V10.6612Z",
    fill: "#B3B3B3"
  }), React.createElement("path", {
    d: "M16.8615 8.81558C16.8615 8.47571 17.137 8.2002 17.4769 8.2002H21.563C21.9029 8.2002 22.1784 8.47571 22.1784 8.81558V8.81558C22.1784 9.15545 21.9029 9.43096 21.563 9.43096H17.4769C17.137 9.43096 16.8615 9.15545 16.8615 8.81558V8.81558Z",
    fill: "#E4E4E4"
  }), React.createElement("path", {
    d: "M16.8615 10.5387C16.8615 10.3347 17.0268 10.1694 17.2307 10.1694H26.0923C26.2962 10.1694 26.4615 10.3347 26.4615 10.5387V10.5387C26.4615 10.7426 26.2962 10.9079 26.0923 10.9079H17.2307C17.0268 10.9079 16.8615 10.7426 16.8615 10.5387V10.5387Z",
    fill: "#E4E4E4"
  }), React.createElement("path", {
    d: "M16.8615 11.7696C16.8615 11.5657 17.0268 11.4004 17.2307 11.4004H28.5538C28.7577 11.4004 28.923 11.5657 28.923 11.7696V11.7696C28.923 11.9735 28.7577 12.1389 28.5538 12.1389H17.2307C17.0268 12.1389 16.8615 11.9735 16.8615 11.7696V11.7696Z",
    fill: "#E4E4E4"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6769 17.3076C13.2209 17.3076 13.6615 16.867 13.6615 16.323C13.6615 15.779 13.2209 15.3384 12.6769 15.3384C12.1329 15.3384 11.6923 15.779 11.6923 16.323C11.6923 16.867 12.1329 17.3076 12.6769 17.3076V17.3076ZM12.6769 17.7999C12.0196 17.7999 10.7076 18.1298 10.7076 18.7845V19.2768H14.6461V18.7845C14.6461 18.1298 13.3341 17.7999 12.6769 17.7999V17.7999Z",
    fill: "#B3B3B3"
  }), React.createElement("path", {
    d: "M16.8615 15.9538C16.8615 15.6139 17.137 15.3384 17.4769 15.3384H22.8923C23.2321 15.3384 23.5077 15.6139 23.5077 15.9538V15.9538C23.5077 16.2936 23.2321 16.5691 22.8923 16.5691H17.4769C17.137 16.5691 16.8615 16.2936 16.8615 15.9538V15.9538Z",
    fill: "#E4E4E4"
  }), React.createElement("path", {
    d: "M16.8615 17.6768C16.8615 17.4729 17.0268 17.3076 17.2307 17.3076H28.5538C28.7577 17.3076 28.923 17.4729 28.923 17.6768V17.6768C28.923 17.8808 28.7577 18.0461 28.5538 18.0461H17.2307C17.0268 18.0461 16.8615 17.8808 16.8615 17.6768V17.6768Z",
    fill: "#E4E4E4"
  }), React.createElement("path", {
    d: "M16.8615 18.9078C16.8615 18.7039 17.0268 18.5386 17.2307 18.5386H26.0923C26.2962 18.5386 26.4615 18.7039 26.4615 18.9078V18.9078C26.4615 19.1117 26.2962 19.277 26.0923 19.277H17.2307C17.0268 19.277 16.8615 19.1117 16.8615 18.9078V18.9078Z",
    fill: "#E4E4E4"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6769 24.4458C13.2209 24.4458 13.6615 24.0052 13.6615 23.4612C13.6615 22.9172 13.2209 22.4766 12.6769 22.4766C12.1329 22.4766 11.6923 22.9172 11.6923 23.4612C11.6923 24.0052 12.1329 24.4458 12.6769 24.4458V24.4458ZM12.6769 24.9381C12.0196 24.9381 10.7076 25.2679 10.7076 25.9227V26.415H14.6461V25.9227C14.6461 25.2679 13.3341 24.9381 12.6769 24.9381V24.9381Z",
    fill: "#B3B3B3"
  }), React.createElement("path", {
    d: "M16.8615 23.0919C16.8615 22.7521 17.137 22.4766 17.4769 22.4766H20.4307C20.7706 22.4766 21.0461 22.7521 21.0461 23.0919V23.0919C21.0461 23.4318 20.7706 23.7073 20.4307 23.7073H17.4769C17.137 23.7073 16.8615 23.4318 16.8615 23.0919V23.0919Z",
    fill: "#E4E4E4"
  }), React.createElement("path", {
    d: "M16.8615 24.815C16.8615 24.6111 17.0268 24.4458 17.2307 24.4458H29.7846C29.9885 24.4458 30.1538 24.6111 30.1538 24.815V24.815C30.1538 25.019 29.9885 25.1843 29.7846 25.1843H17.2307C17.0268 25.1843 16.8615 25.019 16.8615 24.815V24.815Z",
    fill: "#E4E4E4"
  }), React.createElement("path", {
    d: "M16.8615 26.0455C16.8615 25.8416 17.0268 25.6763 17.2307 25.6763H28.5538C28.7577 25.6763 28.923 25.8416 28.923 26.0455V26.0455C28.923 26.2494 28.7577 26.4147 28.5538 26.4147H17.2307C17.0268 26.4147 16.8615 26.2494 16.8615 26.0455V26.0455Z",
    fill: "#E4E4E4"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6769 31.5845C13.2209 31.5845 13.6615 31.1438 13.6615 30.5998C13.6615 30.0558 13.2209 29.6152 12.6769 29.6152C12.1329 29.6152 11.6923 30.0558 11.6923 30.5998C11.6923 31.1438 12.1329 31.5845 12.6769 31.5845V31.5845ZM12.6769 32.0768C12.0196 32.0768 10.7076 32.4066 10.7076 33.0614V33.5537H14.6461V33.0614C14.6461 32.4066 13.3341 32.0768 12.6769 32.0768V32.0768Z",
    fill: "#B3B3B3"
  }), React.createElement("path", {
    d: "M16.8615 30.2306C16.8615 29.8908 17.137 29.6152 17.4769 29.6152H24.8615C25.2014 29.6152 25.4769 29.8908 25.4769 30.2306V30.2306C25.4769 30.5705 25.2014 30.846 24.8615 30.846H17.4769C17.137 30.846 16.8615 30.5705 16.8615 30.2306V30.2306Z",
    fill: "#E4E4E4"
  }), React.createElement("path", {
    d: "M16.8615 31.9537C16.8615 31.7498 17.0268 31.5845 17.2307 31.5845H26.0923C26.2962 31.5845 26.4615 31.7498 26.4615 31.9537V31.9537C26.4615 32.1576 26.2962 32.3229 26.0923 32.3229H17.2307C17.0268 32.3229 16.8615 32.1576 16.8615 31.9537V31.9537Z",
    fill: "#E4E4E4"
  }), React.createElement("path", {
    d: "M16.8615 33.1847C16.8615 32.9807 17.0268 32.8154 17.2307 32.8154H28.5538C28.7577 32.8154 28.923 32.9807 28.923 33.1847V33.1847C28.923 33.3886 28.7577 33.5539 28.5538 33.5539H17.2307C17.0268 33.5539 16.8615 33.3886 16.8615 33.1847V33.1847Z",
    fill: "#E4E4E4"
  }));
};
/* eslint-enable */

var VipsIcon = function VipsIcon(props) {
  return React.createElement("svg", _extends$1({
    width: "42",
    height: "42",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3964 2.5658C17.6338 2.5658 17.8262 2.75821 17.8262 2.99556C17.8262 5.24925 17.9228 7.72854 18.387 9.63498C18.6194 10.5895 18.9352 11.3612 19.3464 11.8862C19.7456 12.3959 20.2253 12.6652 20.8345 12.6652C21.0719 12.6652 21.2643 12.8576 21.2643 13.095C21.2643 13.3323 21.0719 13.5247 20.8345 13.5247C19.9157 13.5247 19.2017 13.0954 18.6697 12.4162C18.1498 11.7523 17.797 10.8449 17.5519 9.83833C17.0611 7.82268 16.9667 5.25227 16.9667 2.99556C16.9667 2.75821 17.1591 2.5658 17.3964 2.5658Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2726 2.5658C24.0353 2.5658 23.8429 2.75821 23.8429 2.99556C23.8429 5.24925 23.7463 7.72854 23.2821 9.63498C23.0496 10.5895 22.7339 11.3612 22.3227 11.8862C21.9235 12.3959 21.4438 12.6652 20.8345 12.6652C20.5972 12.6652 20.4048 12.8576 20.4048 13.095C20.4048 13.3323 20.5972 13.5247 20.8345 13.5247C21.7533 13.5247 22.4674 13.0954 22.9994 12.4162C23.5193 11.7523 23.8721 10.8449 24.1172 9.83833C24.608 7.82268 24.7024 5.25227 24.7024 2.99556C24.7024 2.75821 24.51 2.5658 24.2726 2.5658Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3881 11.8057C13.4387 11.8057 12.6691 12.5754 12.6691 13.5248V30.7152C12.6691 31.6646 13.4387 32.4343 14.3881 32.4343H27.281C28.2304 32.4343 29 31.6646 29 30.7152V13.5248C29 12.5754 28.2304 11.8057 27.281 11.8057H14.3881ZM20.8345 14.3843C21.3092 14.3843 21.6941 13.9995 21.6941 13.5248C21.6941 13.0501 21.3092 12.6652 20.8345 12.6652C20.3598 12.6652 19.975 13.0501 19.975 13.5248C19.975 13.9995 20.3598 14.3843 20.8345 14.3843Z",
    fill: "#D9A9FF"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3964 2.5658C17.6338 2.5658 17.8262 2.75821 17.8262 2.99556C17.8262 5.24925 17.9228 7.72854 18.387 9.63498C18.6194 10.5895 18.9352 11.3612 19.3464 11.8862C19.7456 12.3959 20.2253 12.6652 20.8345 12.6652C21.0719 12.6652 21.2643 12.8576 21.2643 13.095C21.2643 13.3323 21.0719 13.5247 20.8345 13.5247C19.9157 13.5247 19.2017 13.0954 18.6697 12.4162C18.1498 11.7523 17.797 10.8449 17.5519 9.83833C17.0611 7.82268 16.9667 5.25227 16.9667 2.99556C16.9667 2.75821 17.1591 2.5658 17.3964 2.5658Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9419 15.8884C21.1281 15.8884 21.2931 16.0083 21.3507 16.1854L22.2432 18.9322H25.1314C25.3176 18.9322 25.4826 19.0521 25.5401 19.2292C25.5977 19.4063 25.5346 19.6003 25.384 19.7097L23.0474 21.4073L23.9399 24.1542C23.9974 24.3313 23.9344 24.5253 23.7838 24.6347C23.6331 24.7441 23.4292 24.7441 23.2786 24.6347L20.9419 22.937L18.6053 24.6347C18.4547 24.7441 18.2507 24.7441 18.1001 24.6347C17.9495 24.5253 17.8865 24.3313 17.944 24.1542L18.8365 21.4073L16.4999 19.7097C16.3493 19.6003 16.2862 19.4063 16.3438 19.2292C16.4013 19.0521 16.5663 18.9322 16.7525 18.9322H19.6407L20.5332 16.1854C20.5907 16.0083 20.7558 15.8884 20.9419 15.8884ZM20.9419 17.7089L20.3617 19.4948C20.3041 19.6719 20.1391 19.7918 19.9529 19.7918H18.0752L19.5943 20.8955C19.7449 21.0049 19.808 21.1989 19.7504 21.376L19.1702 23.1619L20.6893 22.0581C20.84 21.9487 21.0439 21.9487 21.1945 22.0581L22.7137 23.1619L22.1334 21.376C22.0759 21.1989 22.1389 21.0049 22.2896 20.8955L23.8087 19.7918H21.9309C21.7448 19.7918 21.5797 19.6719 21.5222 19.4948L20.9419 17.7089Z",
    fill: "#FFED5C"
  }), React.createElement("path", {
    d: "M14.3881 27.2771C14.3881 27.0397 14.5805 26.8473 14.8179 26.8473H20.6197C20.857 26.8473 21.0494 27.0397 21.0494 27.2771V27.7068C21.0494 27.9442 20.857 28.1366 20.6197 28.1366H14.8179C14.5805 28.1366 14.3881 27.9442 14.3881 27.7068V27.2771Z",
    fill: "white",
    fillOpacity: "0.4"
  }), React.createElement("path", {
    d: "M14.3881 29.3184C14.3881 29.1404 14.5324 28.9961 14.7104 28.9961H18.1485C18.3265 28.9961 18.4709 29.1404 18.4709 29.3184C18.4709 29.4964 18.3265 29.6407 18.1485 29.6407H14.7104C14.5324 29.6407 14.3881 29.4964 14.3881 29.3184Z",
    fill: "white",
    fillOpacity: "0.4"
  }), React.createElement("path", {
    d: "M14.3881 30.3928C14.3881 30.2148 14.5324 30.0705 14.7104 30.0705H20.2973C20.4754 30.0705 20.6197 30.2148 20.6197 30.3928C20.6197 30.5708 20.4754 30.7151 20.2973 30.7151H14.7104C14.5324 30.7151 14.3881 30.5708 14.3881 30.3928Z",
    fill: "white",
    fillOpacity: "0.4"
  }));
};
/* eslint-enable */

var HeaderContext = createContext([{}, function () {}]);

var HeaderContextProvider = function HeaderContextProvider(props) {
  var _useState = useState(props),
      _useState2 = _slicedToArray(_useState, 2),
      options = _useState2[0],
      setOptions = _useState2[1];

  useEffect(function () {
    setOptions(props);
  }, [props]);
  return React.createElement(HeaderContext.Provider, {
    value: options
  }, props.children);
};

var AppMenu = function AppMenu() {
  var _useContext = useContext(HeaderContext),
      authUser = _useContext.authUser;

  function checkRole(allowedRoles) {
    var user = authUser;
    var roles = user.g.map(function (org) {
      return org.r;
    });
    var check = false;
    roles.forEach(function (role) {
      if (allowedRoles.includes(role)) {
        check = true;
      }
    });
    return check;
  }
  return React.createElement("div", {
    className: "app-container"
  }, process.env.REACT_APP_PORTAL_URL && checkRole(LEGACY_PORTAL) && React.createElement(Button, {
    flat: true,
    className: "app-icon",
    href: process.env.REACT_APP_PORTAL_URL
  }, React.createElement(LegacyPortalIcon, null), React.createElement("div", {
    className: "app-name"
  }, "Legacy Portal")), process.env.REACT_APP_LIVE_URL && checkRole(LIVE) && React.createElement(Button, {
    flat: true,
    className: "app-icon",
    href: process.env.REACT_APP_LIVE_URL
  }, React.createElement(LiveIcon, null), React.createElement("div", {
    className: "app-name"
  }, "Live")), process.env.REACT_APP_ANALYTICS_URL && checkRole(ANALYTICS) && React.createElement(Button, {
    flat: true,
    className: "app-icon",
    href: process.env.REACT_APP_ANALYTICS_URL
  }, React.createElement(AnalyticsIcon$1, null), React.createElement("div", {
    className: "app-name"
  }, "Analytics")), process.env.REACT_APP_SCHEDULER_URL && checkRole(SCHEDULER) && React.createElement(Button, {
    flat: true,
    className: "app-icon",
    href: process.env.REACT_APP_SCHEDULER_URL
  }, React.createElement(SchedulerIcon, null), React.createElement("div", {
    className: "app-name"
  }, "Scheduler")), process.env.REACT_APP_API_URL && checkRole(API) && React.createElement(Button, {
    flat: true,
    className: "app-icon",
    href: process.env.REACT_APP_API_URL
  }, React.createElement(ApiIcon, null), React.createElement("div", {
    className: "app-name"
  }, "API")), process.env.REACT_APP_DEVICES_URL && checkRole(DEVICES) && React.createElement(Button, {
    flat: true,
    className: "app-icon",
    href: process.env.REACT_APP_DEVICES_URL
  }, React.createElement(DevicesIcon, null), React.createElement("div", {
    className: "app-name"
  }, "Devices")), process.env.REACT_APP_EDUCATION_URL && checkRole(EDUCATION) && React.createElement(Button, {
    flat: true,
    className: "app-icon",
    target: "_blank",
    href: process.env.REACT_APP_EDUCATION_URL
  }, React.createElement(EducationIcon, null), React.createElement("div", {
    className: "app-name"
  }, "Education")), process.env.REACT_APP_VIP_MANAGER_URL && checkRole(VIP_MANAGER) && React.createElement(Button, {
    flat: true,
    className: "app-icon",
    href: process.env.REACT_APP_VIP_MANAGER_URL
  }, React.createElement(VipsIcon, null), React.createElement("div", {
    className: "app-name"
  }, "Vip Manager")), process.env.REACT_APP_PREPAID_PASS_MANAGER && checkRole(PREPAID_PASS_MANAGER) && React.createElement(Button, {
    flat: true,
    className: "app-icon",
    href: process.env.REACT_APP_PREPAID_PASS_MANAGER
  }, React.createElement(PrepaidPassManagerIcon, null), React.createElement("div", {
    className: "app-name"
  }, "Prepaid Pass Manager")), process.env.REACT_APP_API_PROVISIONING_URL && checkRole(API_PROVISIONING) && React.createElement(Button, {
    flat: true,
    className: "app-icon",
    href: process.env.REACT_APP_API_PROVISIONING_URL
  }, React.createElement(ApiProvisioningIcon, null), React.createElement("div", {
    className: "app-name"
  }, "API Provisioning")), process.env.REACT_APP_USERS_URL && checkRole(USERS) && React.createElement(Button, {
    flat: true,
    className: "app-icon",
    href: process.env.REACT_APP_USERS_URL
  }, React.createElement(UsersIcon, null), React.createElement("div", {
    className: "app-name"
  }, "Users")), process.env.REACT_APP_NETWORK_DIAGRAM_URL && checkRole(NETWORK_DIAGRAM) && React.createElement(Button, {
    flat: true,
    className: "app-icon",
    href: process.env.REACT_APP_NETWORK_DIAGRAM_URL
  }, React.createElement(NetworkDiagramIcon, null), React.createElement("div", {
    className: "app-name"
  }, "Network Diagram")), React.createElement(Button, {
    flat: true,
    className: "app-container-view-all",
    href: process.env.REACT_APP_SUITE_URL
  }, "view all apps"));
};

var AppDrawerButton = function AppDrawerButton(_ref) {
  var className = _ref.className,
      buttonColor = _ref.buttonColor;
  return React.createElement("div", {
    id: "app-dropdown-button",
    className: className
  }, React.createElement(HeaderDropDown, {
    dropDownContent: React.createElement(AppMenu, null),
    idName: "app-dropdown"
  }, React.createElement(AppDrawerIcon, {
    color: buttonColor,
    width: "24px"
  })));
};

var css$4 = "#user-dropdown-button {\n  width: 2rem;\n  height: 32px; }\n  #user-dropdown-button .md-btn--text {\n    width: 100%;\n    height: 100%;\n    min-width: 100%;\n    margin: 0;\n    padding: 0; }\n";
styleInject(css$4);

var css$5 = ".user-menu-container {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem; }\n  .user-menu-container .user-menu-top {\n    align-items: center;\n    display: flex;\n    margin-bottom: 0.625rem; }\n    .user-menu-container .user-menu-top .user-avatar {\n      height: 4rem;\n      flex-shrink: 0;\n      font-size: 1.625rem;\n      margin-right: 1rem;\n      width: 4rem; }\n    .user-menu-container .user-menu-top .user-details {\n      align-items: flex-start;\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start; }\n      .user-menu-container .user-menu-top .user-details .user-name {\n        font-family: \"Avenir Next LT W01 Demi\", Arial;\n        font-size: 1rem;\n        font-weight: bold;\n        margin-bottom: 0.375rem; }\n      .user-menu-container .user-menu-top .user-details .user-email {\n        color: rgba(0, 0, 0, 0.6);\n        font-size: 0.8125rem; }\n  .user-menu-container .user-menu-bottom {\n    display: flex;\n    flex-direction: column; }\n    .user-menu-container .user-menu-bottom .user-bottom-menu-items {\n      align-items: center;\n      border-radius: 0.25rem;\n      display: flex;\n      font-size: 0.875rem;\n      line-height: 1rem; }\n      .user-menu-container .user-menu-bottom .user-bottom-menu-items .user-bottom-menu-icon {\n        margin-right: 1rem; }\n";
styleInject(css$5);

var SignOutButton = function SignOutButton(_ref) {
  var signOut = _ref.signOut,
      mobile = _ref.mobile;

  function handleSignOut() {
    signOut();
  }
  return React.createElement(Button, {
    onClick: handleSignOut,
    flat: true,
    className: !mobile ? 'user-bottom-menu-items' : 'mobile-sign-out-button'
  }, React.createElement("div", {
    className: !mobile ? 'user-bottom-menu-icon' : 'mobile-sign-out-icon'
  }, React.createElement(ExitLeftIcon, {
    height: "24px",
    width: "24px",
    color: "rgba(0,0,0,.5)"
  })), React.createElement("div", {
    className: mobile && 'md-tile-text--primary'
  }, "Sign out"));
};

var UserMenu = function UserMenu() {
  var _useContext = useContext(HeaderContext),
      authUser = _useContext.authUser,
      signOut = _useContext.signOut,
      adminMenu = _useContext.adminMenu;

  function isGlobalAdmin() {
    if (authUser.g.filter(function (rel) {
      return rel.r === 'GLOBAL_ADMIN';
    }).length > 0 || authUser.gu) {
      return true;
    }
  }
  return React.createElement("div", null, React.createElement("div", {
    className: "user-menu-container"
  }, React.createElement("div", {
    className: "user-menu-top"
  }, React.createElement("div", {
    className: "user-avatar"
  }, !!authUser && "".concat(authUser.fn[0]).concat(authUser.ln[0])), React.createElement("div", {
    className: "user-details"
  }, React.createElement("div", {
    className: "user-name"
  }, !!authUser && "".concat(authUser.fn, " ").concat(authUser.ln)), React.createElement("div", {
    className: "user-email"
  }, !!authUser && "".concat(authUser.e)))), React.createElement("div", {
    className: "user-menu-bottom"
  }, React.createElement(SignOutButton, {
    id: "user-dropdown-sign-out",
    signOut: signOut
  }))), isGlobalAdmin() && adminMenu);
};

var UserButton = function UserButton(_ref) {
  var authUser = _ref.authUser,
      className = _ref.className;
  return React.createElement("div", {
    id: "user-dropdown-button",
    className: className
  }, React.createElement(HeaderDropDown, {
    dropDownContent: React.createElement(UserMenu, null),
    idName: "user-dropdown"
  }, React.createElement("div", {
    className: "user-avatar"
  }, authUser && "".concat(authUser.fn[0]).concat(authUser.ln[0]))));
};

var DesktopHeader = function DesktopHeader(_ref) {
  var logoClick = _ref.logoClick,
      logoSrc = _ref.logoSrc,
      logoWidth = _ref.logoWidth,
      backgroundColor = _ref.backgroundColor;

  var _useContext = useContext(HeaderContext),
      authUser = _useContext.authUser,
      buttonColor = _useContext.buttonColor,
      appMenuActive = _useContext.appMenuActive;

  function handleLogoClick() {
    if (logoClick) {
      logoClick();
    }
  }

  return React.createElement(React.Fragment, null, React.createElement("header", {
    id: "header",
    className: "header-desktop",
    style: {
      backgroundColor: backgroundColor
    }
  }, React.createElement("div", {
    className: "logo-container",
    onClick: function onClick() {
      return handleLogoClick();
    }
  }, React.createElement("img", {
    src: logoSrc,
    alt: "parkhub logo",
    width: logoWidth
  })), React.createElement("div", {
    className: "desktop-header-actions"
  }, !!authUser && React.createElement(React.Fragment, null, appMenuActive && React.createElement(AppDrawerButton, {
    id: "desktop-header-app-drawer",
    className: "desktop-header-action-child",
    buttonColor: buttonColor
  }), React.createElement(UserButton, {
    id: "desktop-header-user-menu",
    className: "desktop-header-action-child",
    authUser: authUser
  })))));
};

var css$6 = "/* APP COLORS */\n/* TEXTURES */\n/* FONTS */\n/* SCREEN SIZES */\n.ghosting-info {\n  align-items: center;\n  background: rgba(0, 0, 0, 0.1);\n  color: rgba(18, 18, 18, 0.7);\n  display: flex;\n  font-family: \"Avenir Next LT W01 Demi\", Arial;\n  font-size: 0.875rem;\n  height: 2.25rem;\n  justify-content: center;\n  line-height: 1.0625rem;\n  margin: auto;\n  text-transform: uppercase;\n  width: 100%; }\n\n.viewing-as {\n  padding-left: 0.75rem; }\n";
styleInject(css$6);

function GhostingView(props) {
  return React.createElement("div", {
    className: "ghosting-info"
  }, React.createElement(FontIcon, null, "person"), React.createElement("div", {
    className: "viewing-as"
  }, "Viewing as ", props.authUser.fn, " ", props.authUser.ln));
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var warn_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var warn = function warn(s) {
  console.warn('[react-gtm]', s);
};

exports.default = warn;
});

unwrapExports(warn_1);

var Snippets_1 = createCommonjsModule(function (module) {



var _warn2 = _interopRequireDefault(warn_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://developers.google.com/tag-manager/quickstart

var Snippets = {
  tags: function tags(_ref) {
    var id = _ref.id,
        events = _ref.events,
        dataLayer = _ref.dataLayer,
        dataLayerName = _ref.dataLayerName,
        preview = _ref.preview,
        auth = _ref.auth;

    var gtm_auth = '&gtm_auth=' + auth;
    var gtm_preview = '&gtm_preview=' + preview;

    if (!id) (0, _warn2.default)('GTM Id is required');

    var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';

    var script = '\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\', ' + JSON.stringify(events).slice(1, -1) + '});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';\n        j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl+\'' + gtm_auth + gtm_preview + '&gtm_cookies_win=x\';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,\'script\',\'' + dataLayerName + '\',\'' + id + '\');';

    var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);

    return {
      iframe: iframe,
      script: script,
      dataLayerVar: dataLayerVar
    };
  },
  dataLayer: function dataLayer(_dataLayer, dataLayerName) {
    return '\n      window.' + dataLayerName + ' = window.' + dataLayerName + ' || [];\n      window.' + dataLayerName + '.push(' + JSON.stringify(_dataLayer) + ')';
  }
};

module.exports = Snippets;
});

unwrapExports(Snippets_1);

var TagManager_1 = createCommonjsModule(function (module) {



var _Snippets2 = _interopRequireDefault(Snippets_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TagManager = {
  dataScript: function dataScript(dataLayer) {
    var script = document.createElement('script');
    script.innerHTML = dataLayer;
    return script;
  },
  gtm: function gtm(args) {
    var snippets = _Snippets2.default.tags(args);

    var noScript = function noScript() {
      var noscript = document.createElement('noscript');
      noscript.innerHTML = snippets.iframe;
      return noscript;
    };

    var script = function script() {
      var script = document.createElement('script');
      script.innerHTML = snippets.script;
      return script;
    };

    var dataScript = this.dataScript(snippets.dataLayerVar);

    return {
      noScript: noScript,
      script: script,
      dataScript: dataScript
    };
  },
  initialize: function initialize(_ref) {
    var gtmId = _ref.gtmId,
        _ref$events = _ref.events,
        events = _ref$events === undefined ? {} : _ref$events,
        dataLayer = _ref.dataLayer,
        _ref$dataLayerName = _ref.dataLayerName,
        dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName,
        _ref$auth = _ref.auth,
        auth = _ref$auth === undefined ? '' : _ref$auth,
        _ref$preview = _ref.preview,
        preview = _ref$preview === undefined ? '' : _ref$preview;

    var gtm = this.gtm({
      id: gtmId,
      events: events,
      dataLayer: dataLayer || undefined,
      dataLayerName: dataLayerName,
      auth: auth,
      preview: preview
    });
    if (dataLayer) document.head.appendChild(gtm.dataScript);
    document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
    document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
  },
  dataLayer: function dataLayer(_ref2) {
    var _dataLayer = _ref2.dataLayer,
        _ref2$dataLayerName = _ref2.dataLayerName,
        dataLayerName = _ref2$dataLayerName === undefined ? 'dataLayer' : _ref2$dataLayerName;

    if (window[dataLayerName]) return window[dataLayerName].push(_dataLayer);
    var snippets = _Snippets2.default.dataLayer(_dataLayer, dataLayerName);
    var dataScript = this.dataScript(snippets);
    document.head.appendChild(dataScript);
  }
};

module.exports = TagManager;
});

unwrapExports(TagManager_1);

var dist = createCommonjsModule(function (module) {



var _TagManager2 = _interopRequireDefault(TagManager_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _TagManager2.default;
});

var TagManager$1 = unwrapExports(dist);

var Header = function Header(_ref) {
  var children = _ref.children,
      className = _ref.className,
      signOut = _ref.signOut,
      authUser = _ref.authUser,
      backgroundColor = _ref.backgroundColor,
      buttonColor = _ref.buttonColor,
      logoSrc = _ref.logoSrc,
      logoWidth = _ref.logoWidth,
      ghostingNode = _ref.ghostingNode,
      adminMenu = _ref.adminMenu,
      appMenuActive = _ref.appMenuActive,
      style = _ref.style,
      logoClick = _ref.logoClick;
  useEffect(function () {
    stickybits('#header-container', {
      useStickyClasses: true,
      parentClass: 'sticky-parent',
      stickyClass: 'sticky',
      stuckClass: 'stuck'
    });
    return function () {
      document.getElementById('root').classList.remove('sticky-parent');
    };
  });
  useEffect(function () {
    window.AUTH_USER_81 = authUser;

    if (authUser) {
      TagManager$1.initialize({
        gtmId: process.env.REACT_APP_GTM_ID
      });
    }

    if (!!authUser && window.pendo) {
      if (authUser.gk) {
        window.pendo.identify({
          visitor: {
            id: authUser.gk
          }
        });
      } else {
        window.pendo.identify({
          visitor: {
            id: authUser.pk || '',
            userName: authUser.un || '',
            email: authUser.e || '',
            partyKey: authUser.pk || '',
            firstName: authUser.fn || '',
            lastName: authUser.ln || '',
            displayName: authUser.dn || '',
            role: authUser.g.map(function (o) {
              return o.r;
            }).join(' , '),
            legacyKey: authUser.lk || '',
            legacyOperatorKey: authUser.lok || '',
            environment: authUser.ne
          },
          account: {
            id: authUser.g.map(function (o) {
              return o.o;
            }).join(' , ')
          }
        });
      }
    }
  }, [authUser]);

  function checkRole(user, allowedRoles) {
    var roles = user.g.map(function (org) {
      return org.r;
    });
    var check = false;
    roles.forEach(function (role) {
      if (allowedRoles.includes(role)) {
        check = true;
      }
    });
    return check;
  }

  return React.createElement(HeaderContextProvider, {
    authUser: authUser,
    signOut: signOut,
    adminMenu: adminMenu,
    buttonColor: buttonColor,
    appMenuActive: appMenuActive
  }, React.createElement("div", {
    id: "header-container",
    className: "".concat(className ? className : ''),
    style: style
  }, React.createElement(DesktopHeader, {
    backgroundColor: backgroundColor,
    logoSrc: logoSrc,
    logoWidth: logoWidth,
    logoClick: logoClick
  }), children && React.createElement("div", {
    className: "header-child-container",
    style: {
      backgroundColor: backgroundColor
    }
  }, children), authUser.gu && React.createElement(GhostingView, {
    authUser: authUser
  })), ghostingNode && (checkRole(authUser, ['GLOBAL_ADMIN']) || authUser.gu) && ghostingNode);
};

Header.propTypes = {
  adminMenu: PropTypes.node,
  appMenuActive: PropTypes.bool,
  authUser: PropTypes.object,
  backgroundColor: PropTypes.string,
  buttonColor: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  ghostingNode: PropTypes.node,
  logoClick: PropTypes.func,
  logoSrc: PropTypes.string.isRequired,
  logoWidth: PropTypes.number,
  signOut: PropTypes.func.isRequired,
  style: PropTypes.object
};
Header.defaultProps = {
  appMenuActive: true,
  backgroundColor: '#FFF',
  buttonColor: '#A8A8A8',
  className: '',
  children: null,
  logoWidth: 100,
  style: null
};

var css$7 = ".loading-spinner-container {\n  background: rgba(0, 0, 0, 0.4);\n  left: 0;\n  min-height: 100vh;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 9999; }\n\n.loading-spinner-dual-ring {\n  display: inline-block;\n  height: 16rem;\n  left: 50%;\n  margin: auto;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 16rem; }\n  .loading-spinner-dual-ring:after {\n    animation: loading-spinner-dual-ring 1.2s linear infinite;\n    border: 5px solid rgba(27, 175, 245, 0.4);\n    border-color: rgba(27, 175, 245, 0.4) transparent rgba(27, 175, 245, 0.4) transparent;\n    border-radius: 50%;\n    content: ' ';\n    display: block;\n    height: 244px;\n    margin: 1px;\n    width: 244px; }\n\n@keyframes loading-spinner-dual-ring {\n  0% {\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    border-color: rgba(27, 175, 245, 0.4) transparent rgba(27, 175, 245, 0.4) transparent;\n    transform: rotate(0deg); }\n  25% {\n    border-color: #1abc9c transparent  #1abc9c transparent; }\n  50% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    border-color: #9b59b6 transparent  #9b59b6 transparent;\n    transform: rotate(900deg); }\n  75% {\n    border-color: #e74c3c transparent  #e74c3c transparent; }\n  100% {\n    transform: rotate(1800deg); } }\n\n@keyframes rotate {\n  0% {\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    transform: rotate(0deg); }\n  50% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: rotate(900deg); }\n  100% {\n    transform: rotate(1800deg); } }\n";
styleInject(css$7);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _nonIterableSpread$1(); }

function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$1(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var DisableScroll =
/*#__PURE__*/
function () {
  function DisableScroll() {
    var _this = this;

    _classCallCheck$1(this, DisableScroll);

    _defineProperty$1(this, "handleWheel", function (e) {
      e.preventDefault();
    });

    _defineProperty$1(this, "handleScroll", function () {
      var _window;

      (_window = window).scrollTo.apply(_window, _toConsumableArray$1(_this.lockToScrollPos));
    });

    _defineProperty$1(this, "handleKeydown", function (e) {
      var keys = _this.options.keyboardKeys;
      /* istanbul ignore else */

      if (['INPUT', 'TEXTAREA'].indexOf(e.target.tagName) !== -1) {
        keys = _this.options.authorizedInInputs;
      }
      /* istanbul ignore else */


      if (keys.indexOf(e.keyCode) !== -1) {
        e.preventDefault();
      }
    });

    this.element = null;
    this.lockToScrollPos = [0, 0];
    this.options = {
      disableWheel: true,
      disableScroll: true,
      disableKeys: true,
      keyboardKeys: [32, 33, 34, 35, 36, 37, 38, 39, 40],
      authorizedInInputs: [32, 37, 38, 39, 40] // space: 32, page up: 33, page down: 34, end: 35, home: 36
      // left: 37, up: 38, right: 39, down: 40

    };
    /* istanbul ignore else */

    if (canUseDOM) {
      require('scrollingelement');

      this.element = document.scrollingElement;
    }
  }
  /**
   * Disable Page Scroll
   * @external Node
   *
   * @param {HTMLElement} [element] - DOM Element, usually document.body
   * @param {object} [options] - Change the initial options
   */


  _createClass$1(DisableScroll, [{
    key: "on",
    value: function on(element, options) {
      if (!canUseDOM) return;
      this.element = element || this.element;
      this.options = _objectSpread$1({}, this.options, {}, options);
      var _this$options = this.options,
          disableKeys = _this$options.disableKeys,
          disableScroll = _this$options.disableScroll,
          disableWheel = _this$options.disableWheel;
      /* istanbul ignore else */

      if (disableWheel) {
        document.addEventListener('wheel', this.handleWheel, {
          passive: false
        });
        document.addEventListener('touchmove', this.handleWheel, {
          passive: false
        });
      }
      /* istanbul ignore else */


      if (disableScroll) {
        this.lockToScrollPos = [this.element.scrollLeft || this.element.scrollX, this.element.scrollTop || this.element.scrollY];
        document.addEventListener('scroll', this.handleScroll, {
          passive: false
        });
      }
      /* istanbul ignore else */


      if (disableKeys) {
        document.addEventListener('keydown', this.handleKeydown, {
          passive: false
        });
      }
    }
    /**
     * Re-enable page scrolls
     */

  }, {
    key: "off",
    value: function off() {
      if (!canUseDOM) return;
      document.removeEventListener('wheel', this.handleWheel, {
        passive: false
      });
      document.removeEventListener('touchmove', this.handleWheel, {
        passive: false
      });
      document.removeEventListener('scroll', this.handleScroll, {
        passive: false
      });
      document.removeEventListener('keydown', this.handleKeydown, {
        passive: false
      });
    }
  }]);

  return DisableScroll;
}();

var disableScroll = new DisableScroll();

var LoadingSpinner =
/*#__PURE__*/
function (_Component) {
  _inherits(LoadingSpinner, _Component);

  function LoadingSpinner() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LoadingSpinner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LoadingSpinner)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showSpinner: _this.props.show
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.show && !_this.props.show) {
        _this.timeout = setTimeout(function () {
          return _this.setSpinner(false);
        }, _this.props.delay);
      } else if (!prevProps.show && _this.props.show) {
        _this.setSpinner(true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      clearTimeout(_this.timeout);
    });

    _defineProperty(_assertThisInitialized(_this), "setSpinner", function (value) {
      _this.setState(function () {
        return {
          showSpinner: value
        };
      }, function () {
        return value ? disableScroll.on() : disableScroll.off();
      });
    });

    return _this;
  }

  _createClass(LoadingSpinner, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "loading-spinner-container",
        style: {
          display: this.state.showSpinner ? 'block' : 'none'
        }
      }, React.createElement("div", {
        className: "loading-spinner-dual-ring"
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        show: PropTypes.bool,
        delay: PropTypes.number
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        delay: 2000,
        show: true
      };
    }
  }]);

  return LoadingSpinner;
}(Component);

var getTimeParts_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
function getTimeParts(time, lastUnit) {
    var units = ['ms', 's', 'm', 'h', 'd'];
    var lastUnitIndex = units.findIndex(function (unit) { return unit === lastUnit; });
    var dividers = [1000, 60, 60, 24, 1];
    var dividersAcc = [1, 1000, 60000, 3600000, 86400000];
    var startValue = {
        ms: 0,
        s: 0,
        m: 0,
        h: 0,
        d: 0,
    };
    var output = units.reduce(function (obj, unit, index) {
        if (index > lastUnitIndex) {
            obj[unit] = 0;
        }
        else if (index === lastUnitIndex) {
            obj[unit] = Math.floor(time / dividersAcc[index]);
        }
        else {
            obj[unit] = Math.floor(time / dividersAcc[index]) % dividers[index];
        }
        return obj;
    }, startValue);
    return output;
}
exports.default = getTimeParts;

});

unwrapExports(getTimeParts_1);

var TimerState_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITED = 'INITED';
exports.PLAYING = 'PLAYING';
exports.PAUSED = 'PAUSED';
exports.STOPPED = 'STOPPED';
var TimerState = /** @class */ (function () {
    function TimerState(onChangeStatus) {
        var _this = this;
        if (onChangeStatus === void 0) { onChangeStatus = function (obj) { }; }
        this.state = exports.INITED;
        this.onChange = function () { return onChangeStatus({ state: _this.state }); };
        this.state = exports.INITED;
    }
    TimerState.prototype.getState = function () {
        return this.state;
    };
    TimerState.prototype.setInited = function () {
        if (this.state === exports.INITED) {
            return false;
        }
        this.state = exports.INITED;
        this.onChange();
        return true;
    };
    TimerState.prototype.isInited = function () {
        return this.state === exports.INITED;
    };
    TimerState.prototype.setPlaying = function () {
        if (this.state === exports.PLAYING) {
            return false;
        }
        this.state = exports.PLAYING;
        this.onChange();
        return true;
    };
    TimerState.prototype.isPlaying = function () {
        return this.state === exports.PLAYING;
    };
    TimerState.prototype.setPaused = function () {
        if (this.state !== exports.PLAYING) {
            return false;
        }
        this.state = exports.PAUSED;
        this.onChange();
        return true;
    };
    TimerState.prototype.isPaused = function () {
        return this.state === exports.PAUSED;
    };
    TimerState.prototype.setStopped = function () {
        if (this.state === exports.INITED) {
            return false;
        }
        this.state = exports.STOPPED;
        this.onChange();
        return true;
    };
    TimerState.prototype.isStopped = function () {
        return this.state === exports.STOPPED;
    };
    return TimerState;
}());
exports.default = TimerState;

});

unwrapExports(TimerState_1);
var TimerState_2 = TimerState_1.INITED;
var TimerState_3 = TimerState_1.PLAYING;
var TimerState_4 = TimerState_1.PAUSED;
var TimerState_5 = TimerState_1.STOPPED;

var TimerModel_1 = createCommonjsModule(function (module, exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getTimeParts_1$$1 = __importDefault(getTimeParts_1);
var TimerState_1$$1 = __importDefault(TimerState_1);
var TimerModel = /** @class */ (function () {
    function TimerModel(_a) {
        var initialTime = _a.initialTime, direction = _a.direction, timeToUpdate = _a.timeToUpdate, lastUnit = _a.lastUnit, checkpoints = _a.checkpoints, onChange = _a.onChange;
        this.internalTime = performance.now();
        this.initialTime = initialTime;
        this.time = initialTime;
        this.direction = direction;
        this.timeToUpdate = timeToUpdate;
        this.lastUnit = lastUnit;
        this.checkpoints = checkpoints;
        this.innerState = new TimerState_1$$1.default(onChange);
        this.onChange = onChange;
        this.timerId = null;
    }
    Object.defineProperty(TimerModel.prototype, "state", {
        get: function () {
            return this.innerState.getState();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimerModel.prototype, "timeParts", {
        get: function () {
            return this.getTimeParts(this.computeTime());
        },
        enumerable: true,
        configurable: true
    });
    TimerModel.prototype.getTimeParts = function (time) {
        return getTimeParts_1$$1.default(time, this.lastUnit);
    };
    TimerModel.prototype.setTime = function (time) {
        this.internalTime = performance.now();
        this.initialTime = time;
        this.time = this.initialTime;
        this.onChange(this.getTimeParts(this.time));
    };
    TimerModel.prototype.getTime = function () {
        return this.time;
    };
    TimerModel.prototype.setLastUnit = function (lastUnit) {
        if (this.innerState.isPlaying()) {
            this.pause();
            this.lastUnit = lastUnit;
            this.resume(true);
        }
        else {
            this.lastUnit = lastUnit;
        }
    };
    TimerModel.prototype.setTimeToUpdate = function (interval) {
        if (this.innerState.isPlaying()) {
            this.pause();
            this.timeToUpdate = interval;
            this.resume();
        }
        else {
            this.timeToUpdate = interval;
        }
    };
    TimerModel.prototype.setDirection = function (direction) {
        this.direction = direction;
    };
    TimerModel.prototype.setCheckpoints = function (checkpoints) {
        this.checkpoints = checkpoints;
    };
    TimerModel.prototype.start = function () {
        if (this.innerState.setPlaying()) {
            this.setTimerInterval(true);
        }
    };
    TimerModel.prototype.resume = function (callImmediately) {
        if (callImmediately === void 0) { callImmediately = false; }
        if (!this.innerState.isStopped() && this.innerState.setPlaying()) {
            this.setTimerInterval(callImmediately);
        }
    };
    TimerModel.prototype.pause = function () {
        if (this.innerState.setPaused()) {
            clearInterval(this.timerId);
        }
    };
    TimerModel.prototype.stop = function () {
        if (this.innerState.setStopped()) {
            clearInterval(this.timerId);
        }
    };
    TimerModel.prototype.reset = function () {
        this.time = this.initialTime;
        this.onChange(this.getTimeParts(this.time));
    };
    TimerModel.prototype.setTimerInterval = function (callImmediately) {
        var _this = this;
        if (callImmediately === void 0) { callImmediately = false; }
        if (this.timerId) {
            clearInterval(this.timerId);
        }
        this.internalTime = performance.now();
        var repeatedFunc = function () {
            var oldTime = _this.time;
            var updatedTime = _this.computeTime();
            _this.onChange(_this.getTimeParts(updatedTime));
            _this.checkpoints.map(function (_a) {
                var time = _a.time, callback = _a.callback;
                var checkForForward = time > oldTime && time <= updatedTime;
                var checkForBackward = time < oldTime && time >= updatedTime;
                var checkIntersection = _this.direction === 'backward' ?
                    checkForBackward :
                    checkForForward;
                if (checkIntersection) {
                    callback();
                }
            });
        };
        callImmediately && this.onChange(this.getTimeParts(this.time));
        this.timerId = window.setInterval(repeatedFunc, this.timeToUpdate);
    };
    TimerModel.prototype.computeTime = function () {
        if (this.innerState.isPlaying()) {
            var currentInternalTime = performance.now();
            var delta = Math.abs(currentInternalTime - this.internalTime);
            switch (this.direction) {
                case 'forward':
                    this.time = this.time + delta;
                    this.internalTime = currentInternalTime;
                    return this.time;
                case 'backward': {
                    this.time = this.time - delta;
                    this.internalTime = currentInternalTime;
                    if (this.time < 0) {
                        this.stop();
                        return 0;
                    }
                    return this.time;
                }
                default:
                    return this.time;
            }
        }
        return this.time;
    };
    return TimerModel;
}());
exports.TimerModel = TimerModel;

});

unwrapExports(TimerModel_1);
var TimerModel_2 = TimerModel_1.TimerModel;

var Timer_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(React);

var TimerContext = react_1.default.createContext({
    ms: 0,
    s: 0,
    m: 0,
    h: 0,
    d: 0,
    formatValue: function (value) { return String(value); },
});
var TimerValue = function (_a) {
    var unit = _a.unit, formatValue = _a.formatValue;
    return (react_1.default.createElement(Timer.Consumer, null, function (props) {
        var format = formatValue || props.formatValue;
        return format(props[unit]) || null;
    }));
};
var Milliseconds = function (props) { return (react_1.default.createElement(TimerValue, __assign({ unit: "ms" }, props))); };
var Seconds = function (props) { return (react_1.default.createElement(TimerValue, __assign({ unit: "s" }, props))); };
var Minutes = function (props) { return (react_1.default.createElement(TimerValue, __assign({ unit: "m" }, props))); };
var Hours = function (props) { return (react_1.default.createElement(TimerValue, __assign({ unit: "h" }, props))); };
var Days = function (props) { return (react_1.default.createElement(TimerValue, __assign({ unit: "d" }, props))); };
var Timer = /** @class */ (function (_super) {
    __extends(Timer, _super);
    function Timer(props) {
        var _this = _super.call(this, props) || this;
        var _a = _this.props, initialTime = _a.initialTime, direction = _a.direction, timeToUpdate = _a.timeToUpdate, lastUnit = _a.lastUnit, checkpoints = _a.checkpoints;
        _this.timer = new TimerModel_1.TimerModel({
            initialTime: initialTime,
            direction: direction,
            timeToUpdate: timeToUpdate,
            lastUnit: lastUnit,
            checkpoints: checkpoints,
            onChange: _this.setState.bind(_this),
        });
        _this.state = __assign({}, _this.timer.timeParts, { timerState: 'INITED' });
        _this.start = _this.start.bind(_this);
        _this.pause = _this.pause.bind(_this);
        _this.resume = _this.resume.bind(_this);
        _this.stop = _this.stop.bind(_this);
        _this.reset = _this.reset.bind(_this);
        _this.setTime = _this.setTime.bind(_this);
        _this.getTime = _this.getTime.bind(_this);
        _this.getTimerState = _this.getTimerState.bind(_this);
        _this.setDirection = _this.setDirection.bind(_this);
        _this.setCheckpoints = _this.setCheckpoints.bind(_this);
        return _this;
    }
    Timer.getUI = function (children, renderProps) {
        if (children === null) {
            return null;
        }
        if (Array.isArray(children) || react_1.default.isValidElement(children)) {
            return children;
        }
        if (children.prototype && children.prototype.isReactComponent) {
            return react_1.default.createElement(children, renderProps);
        }
        if (typeof children === 'function') {
            return children(renderProps);
        }
        throw new Error('Please use one of the supported APIs for children');
    };
    Timer.prototype.componentDidMount = function () {
        var startImmediately = this.props.startImmediately;
        startImmediately && this.timer.start();
    };
    Timer.prototype.componentWillUnmount = function () {
        this.timer.stop();
    };
    Timer.prototype.render = function () {
        var _a = this, start = _a.start, pause = _a.pause, resume = _a.resume, stop = _a.stop, reset = _a.reset, getTime = _a.getTime, getTimerState = _a.getTimerState, setTime = _a.setTime, setDirection = _a.setDirection, setCheckpoints = _a.setCheckpoints;
        var _b = this.state, ms = _b.ms, s = _b.s, m = _b.m, h = _b.h, d = _b.d, timerState = _b.timerState;
        var _c = this.props, formatValue = _c.formatValue, children = _c.children;
        return (react_1.default.createElement(TimerContext.Provider, { value: { ms: ms, s: s, m: m, h: h, d: d, formatValue: formatValue } }, Timer.getUI(children, {
            start: start,
            resume: resume,
            pause: pause,
            stop: stop,
            reset: reset,
            getTime: getTime,
            getTimerState: getTimerState,
            setTime: setTime,
            setDirection: setDirection,
            setCheckpoints: setCheckpoints,
            timerState: timerState,
        })));
    };
    Timer.prototype.setTime = function (time) {
        this.timer.setTime(time);
    };
    Timer.prototype.getTime = function () {
        return this.timer.getTime();
    };
    Timer.prototype.getTimerState = function () {
        return this.timer.state;
    };
    Timer.prototype.setDirection = function (direction) {
        this.timer.setDirection(direction);
    };
    Timer.prototype.setCheckpoints = function (checkpoints) {
        this.timer.setCheckpoints(checkpoints);
    };
    Timer.prototype.start = function () {
        this.timer.start();
        this.props.onStart();
    };
    Timer.prototype.stop = function () {
        this.timer.stop();
        this.props.onStop();
    };
    Timer.prototype.pause = function () {
        this.timer.pause();
        this.props.onPause();
    };
    Timer.prototype.reset = function () {
        this.timer.reset();
        this.props.onReset();
    };
    Timer.prototype.resume = function () {
        this.timer.resume();
        this.props.onResume();
    };
    Timer.Consumer = TimerContext.Consumer;
    Timer.Milliseconds = Milliseconds;
    Timer.Seconds = Seconds;
    Timer.Minutes = Minutes;
    Timer.Hours = Hours;
    Timer.Days = Days;
    Timer.defaultProps = {
        timeToUpdate: 1000,
        direction: 'forward',
        initialTime: 0,
        startImmediately: true,
        lastUnit: 'd',
        checkpoints: [],
        children: null,
        formatValue: function (value) { return String(value); },
        onStart: function () { },
        onResume: function () { },
        onPause: function () { },
        onStop: function () { },
        onReset: function () { },
    };
    return Timer;
}(react_1.default.PureComponent));
exports.default = Timer;

});

unwrapExports(Timer_1);

var useTimer_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });


var getTimeParts_1$$1 = __importDefault(getTimeParts_1);
function useTimer(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.initialTime, initialTime = _c === void 0 ? 0 : _c, _d = _b.direction, direction = _d === void 0 ? "forward" : _d, _e = _b.timeToUpdate, timeToUpdate = _e === void 0 ? 1000 : _e, _f = _b.startImmediately, startImmediately = _f === void 0 ? true : _f, _g = _b.lastUnit, lastUnit = _g === void 0 ? "d" : _g, _h = _b.checkpoints, checkpoints = _h === void 0 ? [] : _h, onStart = _b.onStart, onResume = _b.onResume, onPause = _b.onPause, onStop = _b.onStop, onReset = _b.onReset;
    var _j = React.useState(__assign({}, getTimeParts_1$$1.default(initialTime < 0 ? 0 : initialTime, lastUnit), { state: 'INITED' })), timerValues = _j[0], setTimerValues = _j[1];
    var timer = React.useMemo(function () {
        return new TimerModel_1.TimerModel({
            initialTime: initialTime,
            direction: direction,
            timeToUpdate: timeToUpdate,
            lastUnit: lastUnit,
            checkpoints: checkpoints,
            onChange: function (timerValue) {
                return setTimerValues(function (state) { return (__assign({}, state, timerValue)); });
            },
        });
    }, []);
    var setTime = React.useCallback(function (time) { return timer.setTime(time); }, [timer]);
    var getTime = React.useCallback(function () { return timer.getTime(); }, [timer]);
    var getTimerState = React.useCallback(function () { return timer.state; }, [timer]);
    var setDirection = React.useCallback(function (direction) { return timer.setDirection(direction); }, [timer]);
    var setLastUnit = React.useCallback(function (lastUnit) { return timer.setLastUnit(lastUnit); }, [timer]);
    var setCheckpoints = React.useCallback(function (checkpoints) { return timer.setCheckpoints(checkpoints); }, [timer]);
    var setTimeToUpdate = React.useCallback(function (interval) { return timer.setTimeToUpdate(interval); }, [timer]);
    var start = React.useCallback(function () { timer.start(); onStart && onStart(); }, [timer, onStart]);
    var stop = React.useCallback(function () { timer.stop(); onStop && onStop(); }, [timer, onStop]);
    var pause = React.useCallback(function () { timer.pause(); onPause && onPause(); }, [timer, onPause]);
    var reset = React.useCallback(function () { timer.reset(); onReset && onReset(); }, [timer, onReset]);
    var resume = React.useCallback(function () { timer.resume(); onResume && onResume(); }, [timer, onResume]);
    var controls = React.useMemo(function () { return ({
        start: start,
        stop: stop,
        pause: pause,
        reset: reset,
        resume: resume,
        setTime: setTime,
        getTime: getTime,
        getTimerState: getTimerState,
        setDirection: setDirection,
        setLastUnit: setLastUnit,
        setTimeToUpdate: setTimeToUpdate,
        setCheckpoints: setCheckpoints,
    }); }, [
        start, stop, pause, reset, resume,
        setTime, getTime, getTimerState, setDirection, setLastUnit, setTimeToUpdate, setCheckpoints,
    ]);
    React.useEffect(function () {
        if (startImmediately) {
            start();
        }
        return function () {
            stop();
        };
    }, []);
    return {
        controls: controls,
        value: timerValues,
    };
}
exports.useTimer = useTimer;

});

unwrapExports(useTimer_1);
var useTimer_2 = useTimer_1.useTimer;

var build = createCommonjsModule(function (module, exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Timer_1$$1 = __importDefault(Timer_1);
var getTimeParts_1$$1 = __importDefault(getTimeParts_1);
exports.getTimeParts = getTimeParts_1$$1.default;

exports.useTimer = useTimer_1.useTimer;
exports.default = Timer_1$$1.default;

});

var Timer$1 = unwrapExports(build);
var build_1 = build.getTimeParts;
var build_2 = build.useTimer;

var SessionDialog = function SessionDialog(_ref) {
  var visible = _ref.visible,
      onHide = _ref.onHide,
      onContinue = _ref.onContinue,
      onSignOut = _ref.onSignOut,
      onTimeExpire = _ref.onTimeExpire,
      message = _ref.message,
      duration = _ref.duration;

  function handleContinue() {
    if (onContinue) {
      onContinue();
    }

    onHide();
  }

  function handleSignOut() {
    if (onSignOut) {
      onSignOut();
    }

    onHide();
  }

  return React.createElement(DialogContainer, {
    id: "session-dialog",
    visible: visible,
    onHide: onHide,
    "aria-describedby": "session expire",
    modal: true,
    portal: true,
    lastChild: true,
    actions: [{
      onClick: handleSignOut,
      primary: true,
      children: 'Sign out'
    }, {
      onClick: handleContinue,
      primary: true,
      children: 'Continue'
    }]
  }, React.createElement("p", {
    id: "session expire",
    className: "md-color--secondary-text"
  }, message, React.createElement("br", null), React.createElement(Timer$1, {
    initialTime: duration // 60 seconds
    ,
    direction: "backward",
    checkpoints: [{
      time: 0,
      callback: function callback() {
        return onTimeExpire();
      }
    }]
  }, React.createElement(Timer$1.Seconds, null), " seconds")));
};

SessionDialog.propTypes = {
  duration: PropTypes.number,
  message: PropTypes.string,
  onContinue: PropTypes.func,
  onHide: PropTypes.func.isRequired,
  onSignOut: PropTypes.func,
  onTimeExpire: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired
};
SessionDialog.defaultProps = {
  duration: 60000,
  message: 'Your session is about to expire!',
  visible: false
};

export { Header, LoadingSpinner, SessionDialog };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@parkhub/parkhub-ui/dist/index.es.js
// module id = 48
// module chunks = 0